import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import {
  retrieveAllItemsApi,
  retrieveItemByIdApi,
} from "../../../components/api/ItemApiService";
import {
  retrieveFastOffersApi,
  retrieveOfferByIdApi,
} from "../../../components/api/OfferApiService";
import {
  approveOrderApi,
  deleteOrdersApi,
  retrieveAllOrdersApi,
  retrieveFastFilteredOrdersApi,
  retrieveFastOrdersApi,
  retrieveFilteredOrdersApi,
  retrieveMaxOrderNumberApi,
  retrieveOrderByIdApi,
  retrieveSelectedOrdersByIdApi,
  updateOrderApi,
} from "../../../components/api/OrderApiService";
import {
  retrieveAllSamplesApi,
  retrieveSampleByIdApi,
} from "../../../components/api/SampleApiService";
import { retrieveFastStakeholdersApi } from "../../../components/api/StakeholderApiService";
import ExportExcel from "../../../utils/excelExport";
import EditCost from "../CostView/EditCost";
import EditItem from "../ItemView/EditItem";
import EditSample from "../SampleView/EditSample";
import EditVendorOffer from "../VendorOfferView/EditVendorOffer";
import AddVendorOrder from "./AddVendorOrder";
import CreateOrder from "./CreateOrder";
import CreatePurchaseOrderShipment from "./CreatePurchaseOrderShipment";
import ExportPurchaseOrder from "./Dialogs/ExportPurchaseOrder";
import EditVendorOrder from "./EditVendorOrder";
import { retrieveUsersApi } from "../../../components/api/UserApiService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import SampleButton from "./Dialogs/SampleButton";
import ItemButton from "./Dialogs/ItemButton";
import OfferButton from "./Dialogs/OfferButton";
import ApproveOrderButton from "./Dialogs/ApproveOrderButton";
import ClipLoader from "react-spinners/ClipLoader";
import TradeHistoryButton from "./Dialogs/TradeHistoryButton";
import { deleteUserComponentSettingsApi, retrieveUserComponentSettingsApi, retrieveUserReportsApi, saveUserComponentSettingsApi } from "../../../components/api/UserComponentSettingsApiService";
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import SortableItem from "../ShippingInstructionView/Dialogs/SortableItem";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExportShippingView from "./Dialogs/ExportShippingView";
import BlocksDialog from "./Dialogs/BlocksDialog";
import ApprovedEditButton from "../CustomerOfferView/Dialogs/ApproveEditButton";
import FilterSelect from "../../../components/FilterSelect";
import MyFilters from "../../../components/MyFilters";
import { useAuth } from "../../../auth/AuthContext";

const MAX_BULK_SELECTION = 20;

function getValueByPath(obj, path) {
  return path.split(".").reduce((acc, key) => {
    return acc ? acc[key] : undefined;
  }, obj);
}

function descendingComparator(a, b, orderBy) {
  const valueA = getValueByPath(a, orderBy);
  const valueB = getValueByPath(b, orderBy);

  if (valueA == null && valueB == null) return 0;
  if (valueA == null) return 1;
  if (valueB == null) return -1;

  if (orderBy === "timestamp" && typeof valueA === "string") {
    valueA = new Date(valueA);
    valueB = new Date(valueB);
  }

  if (valueB < valueA) {
    return -1;
  }
  if (valueB > valueA) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "editButton",
    disablePadding: true,
    label: "",
    sx: {
      padding: "normal",
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 2,
      display: "flex", alignItems: "center"
    },
    render: (row, rowIndex, { setShowButtons, showButtons, setEditVendorOrder, setOrderData, approveOrder, openDeclineDialog,
      isDeclineDialogOpen, closeDeclineDialog, declineNote, handleDecline, openAssignUserDialog, isAssignUserDialogOpen,
      closeAssignUserDialog, selectedUser, setSelectedUser, selectedRow, users, handleAssignment, setShowShipmentRequestPopup,
      navigate, loadingRecord, cancelOrder, user }) => (
      <>
        <TradeHistoryButton row={row} />
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setShowButtons(!showButtons);
          }}
        >
          <ArrowForwardIosIcon
            style={{
              transform: showButtons
                ? "rotate(180deg)"
                : "rotate(0deg)",
            }}
          />
        </IconButton>
        {showButtons && (
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginLeft: "10px",
            }}
          >
            <ApprovedEditButton
              row={row}
              isApproved={row?.approvalStatus === "Approved"}
              disabled={row?.orderStatus === "Cancelled"}
              onEdit={() => {
                setEditVendorOrder({
                  visible: true,
                  data: row,
                  rowIndex,
                });
              }}
            />


            <Tooltip title="Approve Order">
              <ApproveOrderButton
                row={row}
                approveOrder={approveOrder}>
              </ApproveOrderButton>
            </Tooltip>
            <Tooltip title="Decline Order">
              <IconButton
                color="secondary"
                disabled={
                  row?.approvalStatus === "Declined" ||
                  row?.orderStatus === "Cancelled" ||
                  !row?.assignedUserId
                }
                onClick={() => {
                  if (
                    user?.email ===
                    row?.assignedUserEmail
                  ) {
                    retrieveOrderByIdApi(row?.id)
                      .then((response) => {
                        setOrderData(response?.data);
                        openDeclineDialog(response?.data);
                      })
                      .catch((error) => {
                        window.alert("Failed to retrieve order. Please try again later.");
                      });
                  } else {
                    toast.error(
                      "This order is not assigned to you.",
                    );
                  }
                }}
              >
                <CancelIcon />
              </IconButton>
            </Tooltip>
            <Dialog
              open={isDeclineDialogOpen}
              onClose={closeDeclineDialog}
            >
              <DialogTitle>Decline Order</DialogTitle>
              <DialogContent>
                <Typography variant="body2">
                  Decline Note
                </Typography>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={declineNote}
                  onChange={(e) =>
                    (declineNote = e.target.value)
                  }
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={closeDeclineDialog}>
                  Cancel
                </Button>
                <Button onClick={handleDecline}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>
            <Button
              variant="outlined"
              disabled={row?.approvalStatus === "Approved"}
              onClick={(e) => {
                e.stopPropagation();
                retrieveOrderByIdApi(row?.id)
                  .then((response) => {
                    setOrderData(response?.data);
                    openAssignUserDialog(response?.data);
                  })
                  .catch((error) => {
                    window.alert("Failed to retrieve order. Please try again later.");
                  });
              }}
            >
              Assign
            </Button>

            <Dialog
              open={isAssignUserDialogOpen}
              onClose={closeAssignUserDialog}
            >
              <DialogTitle>
                Assign Order to a User
              </DialogTitle>
              <DialogContent>
                <Select
                  value={selectedUser}
                  onChange={(e) =>
                    setSelectedUser(e.target.value)
                  }
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="" disabled>
                    {selectedRow?.assignedUserName
                      ? selectedRow?.assignedUserName
                      : "Select a User"}
                  </MenuItem>
                  {users.map((user) => (
                    <MenuItem key={user} value={user}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeAssignUserDialog}>
                  Cancel
                </Button>
                <Button
                  onClick={handleAssignment}
                  disabled={!selectedUser}
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>

            <Button
              style={{ whiteSpace: "nowrap" }}
              variant="outlined"
              disabled={
                row?.approvalStatus !== "Approved" ||
                row?.orderStatus === "Cancelled" ||
                row?.orderStatus === "Closed"
              }
              onClick={() => {
                retrieveOrderByIdApi(row?.id)
                  .then((response) => {
                    setShowShipmentRequestPopup({
                      data: response?.data,
                      visible: true,
                    })
                  })
                  .catch((error) => {
                    window.alert("Failed to retrieve order. Please try again later.");
                  });
              }
              }
            >
              Create Shipment Request
            </Button>

            <Button
              style={{ whiteSpace: "nowrap" }}
              variant="outlined"
              disabled={row?.orderStatus === "Cancelled"}
              onClick={() => {
                retrieveOrderByIdApi(row?.id)
                  .then((response) => {
                    navigate("/customer-offer-view", {
                      state: {
                        data: {
                          item: response?.data?.item,
                          offer: response?.data?.offer,
                          company: response?.data?.company,
                          incoterm: response?.data?.incoterm,
                          buyingPrice: response?.data?.finalPrice,
                          buyingPriceCurrency:
                            response?.data?.finalPriceCurrency,
                          numberOfCases:
                            response?.data?.netWeightPerCase &&
                              response?.data?.netWeightPerCase !== 0
                              ? response?.data.remainingQuantity /
                              response?.data.netWeightPerCase
                              : null,
                          netWeightPerCase:
                            response?.data?.netWeightPerCase || null,
                          volume:
                            response?.data?.remainingQuantity || null,
                        },
                        prevLocation: "purchase-order-view",
                      },
                    })
                  })
                  .catch((error) => {
                    window.alert("Failed to retrieve order. Please try again later.");
                  });
              }
              }
            >
              Customer Offer
            </Button>
            {loadingRecord === row?.id ? (
              <ClipLoader color="#000000" loadingRecord={loadingRecord} size={35} />
            ) : (
              <Button
                style={{ whiteSpace: "nowrap" }}
                variant="outlined"
                color="warning"
                disabled={
                  row?.recordStatus === "PASSIVE" ||
                  row?.orderStatus === "Closed"
                }
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you want to cancel PO ${row?.purchaseOrderNumber || ""
                      } for item: ${row?.offerItemBuyingGrade
                      }\nPO Quantity: ${row?.volume || "-"} ${row?.volumeUnit || ""
                      }`,
                    )
                  ) {
                    retrieveOrderByIdApi(row?.id)
                      .then((response) => {
                        cancelOrder(response?.data);
                      })
                      .catch((error) => {
                        window.alert("Failed to retrieve order. Please try again later.");
                      });
                  }
                }}
              >
                Cancel PO
              </Button>
            )}

          </div>
        )}
      </>
    ),
  },
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID",
    sx: {
      position: "sticky",
      left: 50,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.id,
  },
  {
    id: "purchaseOrderNumber",
    numeric: false,
    disablePadding: false,
    label: "SAP PO Number",
    render: (row) => row?.purchaseOrderNumber,
  },
  {
    id: "orderGroupNumber",
    numeric: false,
    disablePadding: false,
    label: "Order Group",
    render: (row) =>
      row?.orderYear && row?.orderGroupNumber
        ? `${row.orderYear}-${row.orderGroupNumber}`
        : row?.orderYear || row?.orderGroupNumber || "",
  },
  {
    id: "assignedUserName",
    numeric: false,
    disablePadding: false,
    label: "Assigned To",
    render: (row) => row?.assignedUserName,
  },
  {
    id: "orderStatus",
    numeric: false,
    disablePadding: true,
    label: "Status",
    render: (row) => row?.orderStatus,
  },
  {
    id: "company",
    numeric: false,
    disablePadding: true,
    label: "Buying Company",
    render: (row) => row?.company,
  },
  {
    id: "offerItemId",
    numeric: true,
    disablePadding: true,
    label: "Item ID",
    render: (row, rowIndex, { setEditItem }) => (
      <ItemButton
        row={row}
        setEditItem={setEditItem}
      />
    ),
  },
  {
    id: "offerItemTobaccoCode",
    numeric: false,
    disablePadding: true,
    label: "Tobacco Code",
    sx: {
      position: "sticky",
      left: 100,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.offerItemTobaccoCode,
  },
  {
    id: "offerItemBuyingGrade",
    numeric: false,
    disablePadding: true,
    label: "Buying Grade",
    sx: {
      position: "sticky",
      left: 150,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.offerItemBuyingGrade,
  },
  {
    id: "offerSalesGrade",
    numeric: false,
    disablePadding: true,
    label: "Sales Grade",
    render: (row) => row?.offerSalesGrade,
  },
  {
    id: "offerItemCrop",
    numeric: true,
    disablePadding: true,
    label: "Crop",
    render: (row) => row?.offerItemCrop,
  },
  {
    id: "offerItemNicotine",
    numeric: true,
    disablePadding: true,
    label: "Nicotine",
    render: (row) => row?.offerItemNicotine,
  },
  {
    id: "offerItemSugar",
    numeric: true,
    disablePadding: true,
    label: "Sugar",
    render: (row) => row?.offerItemSugar,
  },
  {
    id: "offerItemMoisture",
    numeric: true,
    disablePadding: true,
    label: "Moisture",
    render: (row) => row?.offerItemMoisture,
  },
  {
    id: "offerItemOrigin",
    numeric: false,
    disablePadding: true,
    label: "Origin",
    render: (row) => row?.offerItemOrigin,
  },
  {
    id: "offerItemStorage",
    numeric: false,
    disablePadding: true,
    label: "Current Location",
    render: (row) => row?.offerItemStorage,
  },
  {
    id: "offerItemType",
    numeric: false,
    disablePadding: true,
    label: "Type",
    render: (row) => row?.offerItemType,
  },
  {
    id: "warehouse",
    numeric: false,
    disablePadding: true,
    label: "Warehouse",
    render: (row) => row?.warehouse,
  },
  {
    id: "stakeholderCode",
    numeric: true,
    disablePadding: true,
    label: "SAP Vendor Code",
    render: (row) => row?.stakeholderCode,
  },
  {
    id: "stakeholderName",
    numeric: false,
    disablePadding: true,
    label: "Vendor Name",
    render: (row) => row?.stakeholderName,
  },
  {
    id: "firstSampleId",
    numeric: true,
    disablePadding: true,
    label: "Redrawn Sample",
    render: (row, rowIndex, { setEditSample }) => (
      <SampleButton
        row={row}
        id={row?.firstSampleId}
        setEditSample={setEditSample}
      />
    ),
  },
  {
    id: "firstSampleDeliveryDate",
    numeric: true,
    disablePadding: true,
    label: "Redrawn Sample Date",
    render: (row) => (
      row?.firstSampleDeliveryDate
        ? format(
          new Date(
            row?.firstSampleDeliveryDate,
          ),
          "dd/MM/yyyy",
        )
        : ""
    ),
  },
  {
    id: "firstSampleStatus",
    numeric: false,
    disablePadding: true,
    label: "Redrawn Sample Status",
    render: (row) => row?.firstSampleStatus,
  },
  {
    id: "packaging",
    numeric: true,
    disablePadding: true,
    label: "Packaging Type",
    render: (row) => row?.packaging,
  },
  {
    id: "packagingNicotine",
    numeric: true,
    disablePadding: true,
    label: "Packaging Nicotine",
    render: (row) => row?.packagingNicotine,
  },
  {
    id: "packagingSugar",
    numeric: true,
    disablePadding: true,
    label: "Packaging Sugar",
    render: (row) => row?.packagingSugar,
  },
  {
    id: "netWeightPerCase",
    numeric: true,
    disablePadding: true,
    label: "Net Weight Per Carton",
    render: (row) => row?.netWeightPerCase,
  },
  {
    id: "numberOfCases",
    numeric: true,
    disablePadding: true,
    label: "Number Of Cartons",
    render: (row) => row?.numberOfCases,
  },
  {
    id: "volume",
    numeric: true,
    disablePadding: true,
    label: "Quantity (KG)",
    render: (row) =>
      row?.volume
        ? `${new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(row?.volume)} ${row?.volumeUnit
        }`
        : "0.00",
  },
  {
    id: "remainingQuantity",
    numeric: true,
    disablePadding: true,
    label: "Unshipped Quantity (KG)",
    render: (row) =>
      row?.remainingQuantity
        ? `${new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(row?.remainingQuantity)} ${row?.volumeUnit
        }`
        : "0.00",
  },
  {
    id: "offerFirstOfferPrice",
    numeric: true,
    disablePadding: true,
    label: "First Price",
    render: (row) =>
      row?.offerFirstOfferPrice
        ? `${new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(row?.offerFirstOfferPrice)} ${row?.offerFirstOfferPriceCurrency
        }`
        : "0.00",
  },
  {
    id: "offerUsdFirstOfferPrice",
    numeric: true,
    disablePadding: true,
    label: "First Price (USD)",
    render: (row) =>
      row?.offerUsdFirstOfferPrice
        ? `${new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(row?.offerUsdFirstOfferPrice)} USD`
        : "0.00",
  },
  {
    id: "finalPrice",
    numeric: true,
    disablePadding: false,
    label: "Final Price",
    render: (row) =>
      row?.finalPrice
        ? `${new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(row?.finalPrice)} ${row?.finalPriceCurrency
        }`
        : "0.00",
  },
  {
    id: "usdFinalPrice",
    numeric: true,
    disablePadding: false,
    label: "Final Price (USD)",
    render: (row) =>
      row?.usdFinalPrice
        ? `${new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(row?.usdFinalPrice)} USD`
        : "0.00",
  },
  {
    id: "totalAmount",
    numeric: true,
    disablePadding: true,
    label: "Total Amount",
    render: (row) =>
      row?.totalAmount
        ? `${new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(row?.totalAmount)} ${row?.finalPriceCurrency
        }`
        : "0.00",
  },
  {
    id: "usdTotalAmount",
    numeric: true,
    disablePadding: true,
    label: "Total Amount USD",
    render: (row) =>
      row?.totalAmount ?
        row?.usdFinalPrice
          ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row.volume * row.usdFinalPrice)} USD`
          : "0.00" : "0.00",
  },
  {
    id: "contractValueDate",
    numeric: false,
    disablePadding: true,
    label: "Contract Value Date",
    render: (row) => (
      row?.contractValueDate
        ? format(
          new Date(
            row?.contractValueDate,
          ),
          "dd/MM/yyyy",
        )
        : ""
    ),
  },
  {
    id: "incoterm",
    numeric: true,
    disablePadding: true,
    label: "Incoterm",
    render: (row) => row?.incoterm,
  },
  {
    id: "portOfDischarge",
    numeric: true,
    disablePadding: true,
    label: "Port Of Discharge",
    render: (row) => row?.portOfDischarge,
  },
  {
    id: "portOfLoading",
    numeric: true,
    disablePadding: true,
    label: "Port Of Loading",
    render: (row) => row?.portOfLoading,
  },
  {
    id: "paymentTerm",
    numeric: false,
    disablePadding: true,
    label: "Payment Term",
    render: (row) => row?.paymentTerm,
  },
  {
    id: "operationDate",
    numeric: false,
    disablePadding: true,
    label: "Issue Date",
    render: (row) => (
      row?.operationDate
        ? format(
          new Date(
            row?.operationDate,
          ),
          "dd/MM/yyyy",
        )
        : ""
    ),
  },
  {
    id: "estimatedTimeOfDeparture",
    numeric: false,
    disablePadding: true,
    label: "ETD",
    render: (row) => (
      row?.estimatedTimeOfDeparture
        ? format(
          new Date(
            row?.estimatedTimeOfDeparture,
          ),
          "dd/MM/yyyy",
        )
        : ""
    ),
  },
  {
    id: "estimatedTimeOfArrival",
    numeric: false,
    disablePadding: true,
    label: "ETA",
    render: (row) => (
      row?.estimatedTimeOfArrival
        ? format(
          new Date(
            row?.estimatedTimeOfArrival,
          ),
          "dd/MM/yyyy",
        )
        : ""
    ),
  },
  {
    id: "shipmentSchedule",
    numeric: false,
    disablePadding: true,
    label: "Shipment Schedule",
    render: (row) => (
      row?.shipmentSchedule?.length > 100 ? (
        <span
          style={{
            display: "inline-block",
            maxWidth: "350px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "top",
          }}
          title={row?.shipmentSchedule}
        >
          {row?.shipmentSchedule}
        </span>
      ) : (
        row?.shipmentSchedule
      )
    ),
  },
  {
    id: "remark",
    numeric: false,
    disablePadding: true,
    label: "Remark",
    render: (row) => row?.remark,
  },
  {
    id: "comment",
    numeric: false,
    disablePadding: true,
    label: "Comment",
    render: (row) => row?.comment,
  },
  {
    id: "offerId",
    numeric: true,
    disablePadding: true,
    label: "Offer Id",
    render: (row, rowIndex, { setEditVendorOffer }) => (
      <OfferButton
        row={row}
        setEditOffer={setEditVendorOffer}
      />
    ),
  },
  {
    id: "offerNumber",
    numeric: false,
    disablePadding: true,
    label: "Offer Number",
    render: (row) => (
      (row?.offerYear ? row?.offerYear + "-" : "") +
      row?.offerGroupNumber
    ),
  },
  {
    id: "offerDate",
    numeric: false,
    disablePadding: true,
    label: "Offer Date",
    render: (row) => (
      row?.offerDate
        ? format(
          new Date(
            row?.offerDate,
          ),
          "dd/MM/yyyy",
        )
        : ""
    ),
  },
  {
    id: "province",
    numeric: false,
    disablePadding: true,
    label: "Province",
    render: (row) => row?.province,
  },
  {
    id: "shippingTerm",
    numeric: false,
    disablePadding: false,
    label: "Shipping Term",
    render: (row) => row?.shippingTerm,
  },
  {
    id: "contractLink",
    numeric: false,
    disablePadding: false,
    label: "Contract Link",
    render: (row) => {
      const isValidUrl = (url) => {
        try {
          new URL(url);
          return true;
        } catch {
          return false;
        }
      };

      return isValidUrl(row?.contractLink) ? (
        <a
          href={row.contractLink}
          target="_blank"
          rel="noreferrer"
        >
          <Button
            disableElevation
            variant="outlined"
            size="small"
          >
            Contract Link
          </Button>
        </a>
      ) : null;
    },
  },
  {
    id: "approvalStatus",
    numeric: false,
    disablePadding: true,
    label: "SG Approval Status",
    render: (row) => (
      <span>
        {row?.approvalStatus ?? "N/A"}
        {row?.approvalStatus === "Declined" &&
          (row?.declineNote ? ` - ${row?.declineNote}` : "")}
      </span>
    ),
  },
  {
    id: "reservationId",
    numeric: false,
    disablePadding: true,
    label: "Reservation ID",
    render: (row) => row?.reservationId,
  },
  {
    id: "timestamp",
    numeric: false,
    disablePadding: true,
    label: "Creation Time",
    render: (row) => {
      const date = new Date(row?.timestamp);
      return row?.timestamp && !isNaN(date)
        ? format(date, "dd/MM/yyyy HH:mm")
        : "";
    },
  },
  {
    id: "creator",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    render: (row) => row?.creator,
  },
  {
    id: "recordStatus",
    numeric: false,
    disablePadding: true,
    label: "Record Status",
    render: (row) => row?.recordStatus,
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    showButtons,
    visibleColumns = headCells.map(cell => cell.id),
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all",
            }}
          />
        </TableCell>
        {headCells.filter(headCell => visibleColumns.includes(headCell.id))
          .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id))
          .map(headCell => (
            <TableCell
              key={headCell.id}
              align={"center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={
                headCell.id === "editButton"
                  ? {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                  }
                  : headCell.id === "id"
                    ? {
                      position: "sticky",
                      left: showButtons ? 50 + 725 : 50,
                      zIndex: 3,
                    }
                    : headCell.id === "purchaseOrderNumber"
                      ? {
                        position: "sticky",
                        left: showButtons ? 115 + 725 : 115,
                        zIndex: 3,
                      }
                      : headCell.id === "offer.item.tobaccoCode"
                        ? {
                          position: "sticky",
                          left: showButtons ? 274 + 725 : 274,
                          zIndex: 3,
                        }
                        : headCell.id === "offer.item.buyingGrade"
                          ? {
                            position: "sticky",
                            left: showButtons ? 417 + 725 : 417,
                            zIndex: 3,
                          }
                          : null
              }
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function VendorOrderTable({
  visibleRows,
  dense,
  isSelected,
  handleClick,
  emptyRows,
  visibleColumns,
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  setShowButtons,
  showButtons,
  setEditVendorOrder,
  approveOrder,
  setOrderData,
  openDeclineDialog,
  isDeclineDialogOpen,
  closeDeclineDialog,
  declineNote,
  handleDecline,
  openAssignUserDialog,
  isAssignUserDialogOpen,
  closeAssignUserDialog,
  selectedUser,
  setSelectedUser,
  selectedRow,
  users,
  handleAssignment,
  setShowShipmentRequestPopup,
  navigate,
  loadingRecord,
  cancelOrder,
  setEditItem,
  setEditSample,
  setEditVendorOffer,
  user,
}) {
  const activeHeadCells = headCells
    .filter((cell) => visibleColumns.includes(cell.id))
    .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id));

  return (
    <TableContainer style={{ maxHeight: 700 }}>
      <Table
        stickyHeader
        aria-label="sticky table"
        sx={{
          minWidth: 750,
          "& .MuiTableCell-root": {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
          },
          "& .MuiTableCell-head": {
            backgroundColor: "#20315d",
            color: "white",
            borderRight: "1px solid rgba(49, 64, 128, 1)",
          },
        }}
        aria-labelledby="tableTitle"
        size={dense ? "small" : "medium"}
        style={{ width: "max-content" }}
      >
        <EnhancedTableHead
          numSelected={numSelected}
          order={order}
          orderBy={orderBy}
          onSelectAllClick={onSelectAllClick}
          onRequestSort={onRequestSort}
          rowCount={rowCount}
          visibleColumns={visibleColumns}
        />
        <TableBody>
          {visibleRows.map((row, rowIndex) => {
            const isItemSelected = isSelected(row.id);
            const labelId = `enhanced-table-checkbox-${rowIndex}`;
            return (
              <TableRow
                key={row.id}
                hover
                onClick={(e) => handleClick(e, row.id, row)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                selected={isItemSelected}
                style={
                  isItemSelected
                    ? { background: "#d7e7fc" }
                    : row.orderStatus === "PO Created"
                      ? { background: "#c8e6d2" }
                      : row.orderStatus === "Closed"
                        ? { background: "#FFCDD2" }
                        : rowIndex % 2
                          ? { background: "#f0f0f0" }
                          : { background: "white" }
                }
                sx={{
                  cursor: "pointer",
                }}
              >
                <TableCell padding="checkbox" id="checkbox-cell">
                  <Checkbox color="primary" checked={isItemSelected} inputProps={{ "aria-labelledby": labelId }} />
                </TableCell>
                {activeHeadCells.map((cell) => (
                  <TableCell
                    key={cell.id}
                    align="center"
                    sx={cell.sx || {}}
                    id={`tableCell_${cell.id}`}>
                    {typeof cell.render === "function"
                      ? cell.render(row, rowIndex, {
                        setShowButtons, showButtons, setEditVendorOrder, setOrderData, approveOrder, openDeclineDialog,
                        isDeclineDialogOpen, closeDeclineDialog, declineNote, handleDecline, openAssignUserDialog, isAssignUserDialogOpen,
                        closeAssignUserDialog, selectedUser, setSelectedUser, selectedRow, users, handleAssignment, setShowShipmentRequestPopup,
                        navigate, loadingRecord, cancelOrder,
                        setEditItem,
                        setEditSample,
                        setEditVendorOffer, user,
                      })
                      : row[cell.id] || ""}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
          {emptyRows > 0 && (
            <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
              <TableCell colSpan={activeHeadCells.length + 1} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

VendorOrderTable.propTypes = {
  visibleRows: PropTypes.array.isRequired,
  setShowButtons: PropTypes.func.isRequired,
  showButtons: PropTypes.bool.isRequired,
  setEditVendorOrder: PropTypes.func.isRequired,
  approveOrder: PropTypes.func.isRequired,
  setOrderData: PropTypes.func.isRequired,
  openDeclineDialog: PropTypes.func.isRequired,
  isDeclineDialogOpen: PropTypes.bool.isRequired,
  closeDeclineDialog: PropTypes.func.isRequired,
  declineNote: PropTypes.string.isRequired,
  handleDecline: PropTypes.func.isRequired,
  openAssignUserDialog: PropTypes.func.isRequired,
  isAssignUserDialogOpen: PropTypes.bool.isRequired,
  closeAssignUserDialog: PropTypes.func.isRequired,
  selectedUser: PropTypes.string.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  selectedRow: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  handleAssignment: PropTypes.func.isRequired,
  setShowShipmentRequestPopup: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  loadingRecord: PropTypes.string.isRequired,
  cancelOrder: PropTypes.func.isRequired,
  setEditItem: PropTypes.array.isRequired,
  setEditSample: PropTypes.array.isRequired,
  setEditVendorOffer: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
};

function EnhancedTableToolbar(props) {
  const {
    numSelected,
    showFilters,
    setShowFilters,
    rows,
    setAddView,
    selected,
    setExportPoPopup,
    selectedData,
    visibleColumns,
    setVisibleColumns,
    selectedColumns,
    setSelectedColumns,
    selectColumnsDialogOpen,
    setSelectColumnsDialogOpen,
    columnsOrder,
    setColumnsOrder,
    onOpenBulkAssignDialog,
    onOpenBulkApproveDialog,
  } = props;

  const headerMapping = {
    "SAP Purchase Order Number": "purchaseOrderNumber",
    "BP Code": "stakeholderCode",
    "BP Name": "stakeholderName",
    "Databox PO ID": "id",
    "Approval Status": "approvalStatus",
    "Order Status": "orderStatus",
    "Status Deadline": (row) =>
      row?.statusDeadline
        ? format(new Date(row.statusDeadline), "dd/MMM/yyyy")
        : "",
    Company: "company",
    "Item ID": "offerItemId",
    "Tobacco Code": "offerItemTobaccoCode",
    "Buying Grade": "offerItemBuyingGrade",
    "Internal Grade": "offerItemInternalGrade",
    "Sales Grade": "offerSalesGrade",
    Crop: "offerItemCrop",
    Nicotine: "offerItemNicotine",
    Sugar: "offerItemSugar",
    Origin: "offerItemOrigin",
    Storage: "offerItemStorage",
    Type: "offerItemType",
    Packaging: "packaging",
    "Packaging Nicotine": "packagingNicotine",
    "Packaging Sugar": "packagingSugar",
    "Net Weight Per Carton": (row) =>
      row?.netWeightPerCase
        ? {
          v: Number(row.netWeightPerCase),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Number of Cartons": (row) =>
      row?.numberOfCases
        ? {
          v: Number(row.numberOfCases),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Final Price": (row) =>
      row?.finalPrice
        ? {
          v: Number(row.finalPrice),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Final Price Currency": "finalPriceCurrency",
    "USD Final Price": (row) =>
      row?.usdFinalPrice
        ? {
          v: Number(row.usdFinalPrice),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Volume": (row) =>
      row?.volume
        ? {
          v: Number(row.volume),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Volume Unit": "volumeUnit",
    "Total Amount": (row) =>
      row?.totalAmount
        ? {
          v: Number(row.totalAmount),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Remaining Volume": (row) =>
      row?.remainingQuantity
        ? {
          v: Number(row.remainingQuantity),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Total Amount for Remaining Volume": (row) =>
      (row?.remainingQuantity && row.finalPrice)
        ? {
          v: Number((row.remainingQuantity ?? 0) * (row.finalPrice ?? 0)),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    Incoterm: "incoterm",
    "Payment Term": "paymentTerm",
    "Contract Value Date": (row) =>
      row?.contractValueDate
        ? format(new Date(row.contractValueDate), "dd/MMM/yyyy")
        : "",
    "Operation Date": (row) =>
      row?.operationDate
        ? format(new Date(row.operationDate), "dd/MMM/yyyy")
        : "",
    "Estimated Time of Departure": (row) =>
      row?.estimatedTimeOfDeparture
        ? format(new Date(row.estimatedTimeOfDeparture), "dd/MMM/yyyy")
        : "",
    "Estimated Time of Arrival": (row) =>
      row?.estimatedTimeOfArrival
        ? format(new Date(row.estimatedTimeOfArrival), "dd/MMM/yyyy")
        : "",
    Remark: "remark",
    Comment: "comment",
    "Offer ID": "offerId",
    "Offer Group Number": (row) =>
      (row?.offerYear ? row.offerYear + "-" : "") +
      (row?.offerGroupNumber || ""),
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [manageExportOpen, setManageExportOpen] = useState(false);
  const [exportColumns, setExportColumns] = useState(Object.keys(headerMapping));
  const [exportColumnsOrder, setExportColumnsOrder] = useState(Object.keys(headerMapping));
  const [showAddColumnInput, setShowAddColumnInput] = useState(false);
  const [newColumnName, setNewColumnName] = useState('');
  const [customColumns, setCustomColumns] = useState([]);
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState('');
  const [showNewReportInput, setShowNewReportInput] = useState(false);
  const [newReportName, setNewReportName] = useState('');

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setColumnsOrder((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const handleExportDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setExportColumnsOrder((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        const newOrder = [...items];
        newOrder.splice(oldIndex, 1);
        newOrder.splice(newIndex, 0, active.id);
        return newOrder;
      });
    }
  };

  const handleToggle = (id) => {
    setSelectedColumns((prev) => {
      if (prev.includes(id)) {
        // Uncheck the item.
        return prev.filter(item => item !== id);
      } else {
        // Check the item.
        return [...prev, id];
      }
    });
  };

  const handleManageExportClick = async () => {
    try {
      const listResp = await retrieveUserReportsApi('VendorOrderExport');
      setReports(listResp?.data);
      setSelectedReport(listResp?.data[0]?.reportName || 'default');
      const settings = await retrieveUserComponentSettingsApi('VendorOrderExport', listResp?.data[0]?.reportName || 'default');
      // Set default columns order
      const allColumns = Object.keys(headerMapping);
      setExportColumnsOrder(allColumns);

      if (settings?.data?.visibleColumns) {
        try {
          // Try to parse the settings data
          let parsedSettings;

          if (typeof settings?.data?.visibleColumns === 'string') {
            parsedSettings = JSON.parse(settings?.data?.visibleColumns);
          } else {
            // If it's already an object, use it directly
            parsedSettings = settings?.data?.visibleColumns;
          }

          if (Array.isArray(parsedSettings)) {
            // Set the visible columns from saved settings
            setExportColumns(parsedSettings);

            // Create ordered array with visible columns first, then invisible ones
            const invisibleColumns = Object.keys(headerMapping).filter(
              col => !parsedSettings.includes(col)
            );

            setExportColumnsOrder([...parsedSettings, ...invisibleColumns]);
          } else {
            console.warn('Saved settings are not in array format:', parsedSettings);
            setExportColumns([]);
          }
        } catch (e) {
          console.warn('Failed to parse saved settings:', e);
          setExportColumns([]);
        }
      }
      setManageExportOpen(true);
    } catch (error) {
      console.error('Error loading export settings:', error);
      toast.error('Failed to load export settings');
    }
  };

  function createNewExportObject(rows) {
    const newObjects = [];
    rows.forEach((row) => {
      const newObject = {};
      exportColumnsOrder
        .filter(header => exportColumns.includes(header))
        .forEach((header) => {
          const pathOrFunction = headerMapping[header];
          let value;

          if (typeof pathOrFunction === "function") {
            value = pathOrFunction(row);
          } else if (pathOrFunction) {
            const keys = pathOrFunction.split("?.");
            value = row;
            for (const key of keys) {
              if (value == null) break;
              value = value[key];
            }
          }
          newObject[header] = value ?? "";
        });
      newObjects.push(newObject);
    });
    return newObjects;
  }

  async function loadSettings(reportName) {
    try {
      const resp = await retrieveUserComponentSettingsApi(
        'VendorOrderExport',
        reportName
      );
      let parsed = [];
      const raw = resp?.data?.visibleColumns;
      if (typeof raw === 'string') {
        parsed = JSON.parse(raw);
      } else if (Array.isArray(raw)) {
        parsed = raw;
      }
      setExportColumns(parsed);
      const allCols = Object.keys(headerMapping);
      const invisible = allCols.filter(c => !parsed.includes(c));
      setExportColumnsOrder([...parsed, ...invisible]);
    } catch (_) {
      const allCols = Object.keys(headerMapping);
      setExportColumns(allCols);
      setExportColumnsOrder(allCols);
    }
  }

  const handleDeleteReport = async () => {
    if (!selectedReport) return;

    if (selectedReport === "default") {
      toast.error('Default report cannot be deleted.');
      return;
    }

    if (!window.confirm(`Are you sure you want to delete "${selectedReport}"?`)) {
      return;
    }

    // find its DB id
    const report = reports.find(r => r.reportName === selectedReport);
    if (!report) return;

    try {
      // 1) mark it PASSIVE
      await deleteUserComponentSettingsApi('VendorOrderExport', selectedReport);

      toast.success(`Report "${selectedReport}" deleted`);

      // 2) remove it from local list
      const updated = reports.filter(r => r.id !== report.id);
      setReports(updated);

      // 3) pick a new selectedReport (or reset)
      const next = updated.length ? updated[0].reportName : '';
      setSelectedReport(next);

      if (next) {
        // load its saved columns
        await loadSettings(next);
      } else {
        // no reports left → reset to defaults
        const all = Object.keys(headerMapping);
        setExportColumns(all);
        setExportColumnsOrder(all);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to delete report');
    }
  };

  const [deletePopup, setDeletePopup] = useState(false);
  const navigate = useNavigate();

  function formatDate(isoDateString) {
    const date = new Date(isoDateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  function createNewSapObject(rows) {
    const newObjects = [];

    rows.forEach((row, index) => {
      const newObject = {};
      newObject.itemNumber = row?.offerItemTobaccoCode || "";
      newObject.itemDescription = "";
      newObject.quantity = row?.volume || "";
      const finalPrice =
        typeof row?.finalPrice === "number"
          ? row?.finalPrice.toFixed(2)
          : row?.finalPrice || "";
      newObject.unitPrice =
        (row?.finalPriceCurrency || "") + " " + finalPrice.replace(".", ",");
      newObject.discount = "";
      newObject.totalLc =
        (row?.finalPriceCurrency || "") + " " + (row?.totalAmount || "");
      newObject.uomCode = row?.volumeUnit || "";
      newObject.customerPoNumber = "";
      newObject.customerGrade = row?.offerSalesGrade || "";
      newObject.internalGrade = row?.offerItemInternalGrade || "";
      newObject.vendorGrade = row?.offerItemBuyingGrade || "";
      newObject.countryOfOrigin = row?.offerItemOrigin || "";
      newObject.leafType = row?.offerItemType || "";
      newObject.leafForm = row?.offerItemLeafForm || "";
      newObject.cropYear = row?.offerItemCrop || "";
      newObject.kgPerCartonBaleNetWeight = row?.netWeightPerCase || "";
      newObject.numberOfCartons = row?.numberOfCases || "";
      newObject.etaDate = row?.estimatedTimeOfArrival
        ? formatDate(row.estimatedTimeOfArrival)
        : "";
      newObject.etdDate = row?.estimatedTimeOfDeparture
        ? formatDate(row.estimatedTimeOfDeparture)
        : "";
      newObject.moisture = row?.offerItemMoisture || "";
      newObject.nicotine = row?.offerItemNicotine || "";
      newObject.sugar = row?.offerItemSugar || "";
      newObject.containerTruckType = "";
      newObject.cartonPerContainerTruck = "";
      //newObject.kgPerContainerTruck = "";
      //newObject.temperatureTarget = "";
      newObject.numberOfContainers = "";
      newObject.packageType = row?.packaging || "";
      newObject.cartonNumberRange = "";
      newObject.salesQutationReferenceNumber = "";
      newObject.salesQutationReferenceDetails = "";
      newObject.salesQutationReferenceDate = "";
      newObject.netWeight = row?.volume || "";
      newObject.salesOrderDocLineNum = "";
      newObject.salesOrderDocNum = "";
      newObject.salesOrderLineNum = "";

      newObjects.push(newObject);
    });

    return newObjects;
  }

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Dialog
        open={deletePopup}
        onClose={() => setDeletePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete {selected.length} order(s)?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteOrdersApi(selected)
                .then((response) => {
                  console.log(response?.data);
                  toast.success("Purchase order(s) deleted successfully.");
                  window.location.reload();
                })
                .catch((error) => {
                  console.log(error.response?.data);
                  toast.error("Purchase order(s) could not deleted.");
                });

            }}
            autoFocus
          >
            Yes
          </Button>
          <Button onClick={() => setDeletePopup(false)}>No</Button>
        </DialogActions>
      </Dialog>

      <Stack direction="row" spacing={1} alignItems={"center"}>
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
          variant="h6"
          id="tableTitle"
          component="div"
          color="#1E2685"
        >
          Purchase Orders
        </Typography>

        {numSelected > 0 ? (
          <Typography
            sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography></Typography>
        )}
        {/*numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton onClick={() => setDeletePopup(true)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )*/}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            onClick={onOpenBulkAssignDialog}
            disabled={numSelected > MAX_BULK_SELECTION}
          >
            Assign Selected
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            onClick={onOpenBulkApproveDialog}
            disabled={numSelected > MAX_BULK_SELECTION}
          >
            Approve Selected
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            sx={{ minWidth: "130px" }}
            style={{ whiteSpace: "nowrap", marginLeft: 20 }}
            onClick={() => {
              retrieveSelectedOrdersByIdApi(selected, "VENDOR")
                .then((response) => {
                  setTimeout(() => {
                    setExportPoPopup({
                      data: response?.data,
                      visible: true,
                    });
                  }, 1000);
                  toast.success("Purchase orders retrieved successfully.");
                })
                .catch((error) => {
                  toast.error("Purchase orders could not retrieved.");
                });
            }}
          >
            Create PO Excel
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            onClick={() => {
              const orderIdList = selectedData.map((data) => data.id); // Extract IDs from selectedData
              retrieveFilteredOrdersApi({
                orderIdList: orderIdList,
                orderType: "VENDOR",
              }) // Pass the IDs as a DTO
                .then((response) => {
                  console.log(response?.data);
                  navigate("/customer-offer-view", {
                    state: {
                      data: {
                        selectedData: response?.data,
                      },
                      prevLocation: "purchase-order-view",
                    },
                  });
                })
                .catch((error) => {
                  console.error("Failed to retrieve orders:", error);
                  toast.error("Failed to retrieve selected orders.");
                });
            }}
          >
            Create Multiple Customer Offers
          </Button>
        )}
      </Stack>
      <Stack direction={"row"} spacing={1} sx={{ mr: 2 }}>
        <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setSelectColumnsDialogOpen(true)}
        >
          Select Columns
        </Button>

        <Dialog open={selectColumnsDialogOpen} onClose={() => setSelectColumnsDialogOpen(false)}>
          <DialogTitle>Select Columns</DialogTitle>
          <DialogContent>
            {/* Buttons to select/deselect all */}
            <Stack direction="row" spacing={2} mb={2}>
              <Button variant="outlined" onClick={() => setSelectedColumns([...columnsOrder])}>
                Select All
              </Button>
              <Button variant="outlined" onClick={() => setSelectedColumns([])}>
                Select None
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  const defaultOrder = headCells.map((cell) => cell.id);
                  setColumnsOrder(defaultOrder);
                  setSelectedColumns(defaultOrder);
                }}
              >
                Reset
              </Button>
            </Stack>
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext items={columnsOrder} strategy={verticalListSortingStrategy}>
                {columnsOrder.map((columnId) => {
                  // Find the headCell data (label etc.) for this column id.
                  const column = headCells.find(cell => cell.id === columnId);
                  return (
                    <SortableItem
                      key={columnId}
                      id={columnId}
                      label={column.label || column.id}
                      checked={selectedColumns.includes(columnId)}
                      onToggle={() => handleToggle(columnId)}
                    />
                  );
                })}
              </SortableContext>
            </DndContext>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSelectColumnsDialogOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                // Get the ordered list of selected columns according to the current columnsOrder:
                const orderedSelectedColumns = columnsOrder.filter(id => selectedColumns.includes(id));
                const visibleColumnsJson = JSON.stringify(orderedSelectedColumns);
                saveUserComponentSettingsApi("VendorOrderView", "default", visibleColumnsJson)
                  .then((response) => {
                    toast.success("Column settings saved successfully!");
                    // Update the state that controls which columns are rendered in the table.
                    setVisibleColumns(orderedSelectedColumns);
                    setSelectColumnsDialogOpen(false);
                  })
                  .catch((error) => {
                    toast.error("Failed to save column settings.");
                    console.error("Save settings error:", error);
                  });
              }}
            >
              Save Column Settings
            </Button>
          </DialogActions>
        </Dialog>

        <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={handleManageExportClick}
        >
          Manage Export
        </Button>

        <Dialog
          open={manageExportOpen}
          onClose={() => setManageExportOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              width: '600px'  // Set a fixed width
            }
          }}
        >
          <DialogTitle>Manage Export Settings</DialogTitle>
          <DialogContent>
            <FormControl fullWidth size="small" sx={{ mb: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
              <Select
                value={selectedReport}
                onChange={async (e) => {
                  const name = e.target.value;
                  setSelectedReport(name);
                  await loadSettings(name);
                }}
                sx={{ flexGrow: 1 }}
              >
                {reports?.map(r => (
                  <MenuItem key={r.id} value={r.reportName}>
                    {r.reportName}
                  </MenuItem>
                ))}
              </Select>

              <IconButton
                size="small"
                onClick={() => setShowNewReportInput(true)}
                title="New report"
              >
                <AddIcon />
              </IconButton>
              <IconButton
                size="small"
                onClick={handleDeleteReport}
                disabled={!selectedReport}
                title="Delete report"
              >
                <DeleteIcon />
              </IconButton>
            </FormControl>
            {showNewReportInput && (
              <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                <TextField
                  size="small"
                  value={newReportName}
                  onChange={e => setNewReportName(e.target.value)}
                  placeholder="New report name"
                  fullWidth
                />
                <Button
                  variant="contained"
                  onClick={async () => {
                    const name = newReportName.trim();
                    if (!name) return;
                    const defaultCols = Object.keys(headerMapping);
                    await saveUserComponentSettingsApi('VendorOrderExport', name, JSON.stringify(defaultCols));
                    const updated = await retrieveUserReportsApi('VendorOrderExport');
                    setReports(updated?.data);
                    setSelectedReport(name);
                    await loadSettings(name);
                    setNewReportName('');
                    setShowNewReportInput(false);
                  }}
                >
                  Create
                </Button>
                <IconButton onClick={() => setShowNewReportInput(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
            <Stack direction="row" spacing={2} mb={2}>
              <Button
                variant="outlined"
                onClick={() => setExportColumns(Object.keys(headerMapping))}
              >
                Select All
              </Button>
              <Button
                variant="outlined"
                onClick={() => setExportColumns([])}
              >
                Select None
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  setExportColumns(Object.keys(headerMapping));
                  setExportColumnsOrder(Object.keys(headerMapping));
                }}
              >
                Reset
              </Button>
              <Button
                variant="outlined"
                onClick={() => setShowAddColumnInput(true)}
              >
                Add Column
              </Button>
            </Stack>
            {showAddColumnInput && (
              <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                <TextField
                  size="small"
                  value={newColumnName}
                  onChange={(e) => setNewColumnName(e.target.value)}
                  placeholder="Enter column name"
                  fullWidth
                />
                <Button
                  variant="contained"
                  onClick={() => {
                    if (newColumnName.trim()) {
                      const newColumn = newColumnName.trim().replace(/\s+/g, ' ');
                      setCustomColumns([...customColumns, { id: newColumn, label: newColumnName }]);
                      setExportColumns([...exportColumns, newColumn]);
                      setExportColumnsOrder([...exportColumnsOrder, newColumn]);
                      setNewColumnName('');
                      setShowAddColumnInput(false);
                    }
                  }}
                >
                  Add
                </Button>
                <IconButton onClick={() => setShowAddColumnInput(false)}>
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={handleExportDragEnd}
            >
              <SortableContext
                items={exportColumnsOrder}
                strategy={verticalListSortingStrategy}
              >
                {exportColumnsOrder.map((columnId) => (
                  <Box
                    key={columnId}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      width: '100%',
                      // Minimal styling just for layout
                      '& > div:first-of-type': {
                        flex: 1
                      }
                    }}
                  >
                    <SortableItem
                      key={columnId}
                      id={columnId}
                      label={columnId}
                      checked={exportColumns.includes(columnId)}
                      onToggle={() => {
                        if (exportColumns.includes(columnId)) {
                          setExportColumns(exportColumns.filter(col => col !== columnId));
                        } else {
                          setExportColumns([...exportColumns, columnId]);
                        }
                      }}
                    />
                    {customColumns.find(c => c.id === columnId) && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          setCustomColumns(customColumns.filter(c => c.id !== columnId));
                          setExportColumns(exportColumns.filter(col => col !== columnId));
                          setExportColumnsOrder(exportColumnsOrder.filter(col => col !== columnId));
                        }}
                        sx={{ ml: 1 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>
                ))}
              </SortableContext>
            </DndContext>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setManageExportOpen(false)}>Cancel</Button>
            <Button
              onClick={() => {
                // Get visible columns in their current order
                const orderedVisibleColumns = exportColumnsOrder.filter(id => exportColumns.includes(id));

                // Stringify the array before saving
                const settingsString = JSON.stringify(orderedVisibleColumns);

                saveUserComponentSettingsApi('VendorOrderExport', selectedReport, settingsString)
                  .then(() => {
                    toast.success('Export settings saved successfully');
                    setManageExportOpen(false);
                  })
                  .catch(error => {
                    console.error('Error saving export settings:', error);
                    toast.error('Failed to save export settings');
                  });
              }}
              variant="contained"
            >
              Save Export Settings
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleExportClick}
              endIcon={<KeyboardArrowDownIcon />}
            >
              Export Options
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={() => {
                handleClose();
              }}>
                <ExportExcel
                  excelData={createNewExportObject(selectedData)}
                  fileName={"PurchaseOrder-" + selectedReport}
                  buttonLabel="Export Table"
                  buttonProps={{
                    variant: "contained",
                    color: "success",
                    size: "medium",
                  }}
                />
              </MenuItem>
              <MenuItem onClick={() => {
                handleClose();
              }}>
                <ExportShippingView
                  orderType="VENDOR"
                  buttonLabel="Export Shipping View"
                  buttonProps={{ variant: "contained", color: "secondary", size: "medium" }}
                />
              </MenuItem>
            </Menu>
            <ExportExcel
              excelData={createNewExportObject(selectedData)}
              fileName={"PurchaseOrder-" + selectedReport}
              buttonLabel="Export Table"
              buttonProps={{
                variant: "contained",
                color: "success",
                size: "medium",
              }}
            />
          </DialogActions>
        </Dialog>

        <ExportExcel
          excelData={createNewSapObject(selectedData)}
          fileName={"ExcelExportSAP"}
          buttonLabel="SAP Export"
        />
        {/*<Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setAddView(true)}
        >
          Add
        </Button>*/}
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px" }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onOpenBulkAssignDialog: PropTypes.func.isRequired,
  onOpenBulkApproveDialog: PropTypes.func.isRequired,
};

export default function VendorOrderView() {
  const componentName = "VendorOrderView";
  const { user, userLoading } = useAuth();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showFilters, setShowFilters] = useState(false);
  const [addView, setAddView] = useState(false);
  const [addViewStates, setAddViewStates] = useState(null);
  const [rows, setRows] = useState([]);
  const [items, setItems] = useState([]);
  const [samples, setSamples] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [users, setUsers] = useState([]);
  const [isAssignUserDialogOpen, setIsAssignUserDialogOpen] = useState(false);
  const [isDeclineDialogOpen, setIsDeclineDialogOpen] = useState(false);
  const [isBulkAssignDialogOpen, setIsBulkAssignDialogOpen] = useState(false);
  const [isBulkApproveDialogOpen, setIsBulkApproveDialogOpen] = useState(false);
  const [bulkSelectedUser, setBulkSelectedUser] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [offers, setOffers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [showButtons, setShowButtons] = useState(false);
  let declineNote = null;
  const totalVolume = rows.reduce((sum, row) => sum + (row.volume || 0), 0);
  const usdTotalAmount = rows.reduce((sum, row) => sum + (row?.volume ? row?.usdFinalPrice ? (row.volume * row.usdFinalPrice) : 0 : 0), 0);
  const [visibleColumns, setVisibleColumns] = useState(headCells.map(cell => cell.id));
  const [selectColumnsDialogOpen, setSelectColumnsDialogOpen] = useState(false);
  const [columnsOrder, setColumnsOrder] = useState(headCells.map(cell => cell.id));
  const [selectedColumns, setSelectedColumns] = useState(headCells.map(cell => cell.id));

  useEffect(() => {
    retrieveUserComponentSettingsApi(componentName, 'default')
      .then((response) => {
        const allColumnIds = headCells.map(cell => cell.id);
        if (response.data && response.data.visibleColumns) {
          const savedColumns = JSON.parse(response.data.visibleColumns);
          const combinedOrder = [
            ...savedColumns,
            ...allColumnIds.filter(id => !savedColumns.includes(id))
          ];
          setVisibleColumns(savedColumns);
          setColumnsOrder(combinedOrder);
          setSelectedColumns(savedColumns);
        } else {
          setVisibleColumns(allColumnIds);
          setColumnsOrder(allColumnIds);
          setSelectedColumns(allColumnIds);
        }
      })
      .catch((error) => {
        console.error("Error loading column settings:", error);
      });
  }, [componentName]);

  const handleColumnToggle = (columnId) => {
    setVisibleColumns(prev =>
      prev.includes(columnId)
        ? prev.filter(id => id !== columnId)
        : [...prev, columnId]
    );
  };

  const [maxOrderGroupNumber, setMaxOrderGroupNumber] = useState();

  const [showOrderPopup, setShowOrderPopup] = useState({
    visible: false,
    data: null,
  });
  const [exportPoPopup, setExportPoPopup] = useState({
    visible: false,
    data: null,
  });
  const [editItem, setEditItem] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editCost, setEditCost] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editSample, setEditSample] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editVendorOffer, setEditVendorOffer] = useState({
    visible: false,
    data: null,
    index: null,
  });

  function mapOrder(order) {
    return {
      ...order,
      assignedUserId: order?.assignedUser?.id,
      assignedUserName: order?.assignedUser?.name,
      assignedUserEmail: order?.assignedUser?.email,
      stakeholderId: order?.offer?.stakeholder?.id,
      stakeholderCode: order?.offer?.stakeholder?.code,
      stakeholderName: order?.offer?.stakeholder?.name,
      firstSampleId: order?.firstSample?.id,
      firstSampleDeliveryDate: order?.firstSample?.deliveryDate,
      firstSampleStatus: order?.firstSampleStatus,
      offerFirstOfferPrice: order?.offer?.firstOfferPrice,
      offerFirstOfferPriceCurrency: order?.offer?.firstOfferPriceCurrency,
      offerUsdFirstOfferPrice: order?.offer?.usdFirstOfferPrice,
      offerId: order?.offer?.id,
      offerDate: order?.offer?.offerDate,
      offerYear: order?.offer?.offerYear,
      offerGroupNumber: order?.offer?.offerGroupNumber,
      offerItemId: order?.offer?.item?.id,
      offerItemTobaccoCode: order?.offer?.item?.tobaccoCode,
      offerItemBuyingGrade: order?.offer?.item?.buyingGrade,
      offerSalesGrade: order?.offer?.salesGrade,
      offerItemOrigin: order?.offer?.item?.origin,
      offerItemType: order?.offer?.item?.type,
      offerItemCrop: order?.offer?.item?.crop,
      offerItemStorage: order?.offer?.item?.storage,
      offerItemNicotine: order?.offer?.item?.nicotine,
      offerItemSugar: order?.offer?.item?.sugar,
      offerItemMoisture: order?.offer?.item?.moisture,
    };
  }

  const openDeclineDialog = (row) => {
    setSelectedRow(row);
    setIsDeclineDialogOpen(true);
  };
  const closeDeclineDialog = () => {
    setIsDeclineDialogOpen(false);
    setSelectedRow(null);
  };

  const openAssignUserDialog = (row) => {
    setSelectedRow(row);
    setIsAssignUserDialogOpen(true);
  };
  const closeAssignUserDialog = () => {
    setIsAssignUserDialogOpen(false);
    setSelectedRow(null);
    setSelectedUser("");
  };

  const handleAssignment = () => {
    if (selectedRow && selectedUser) {
      const assignmentDate = new Date();
      retrieveOrderByIdApi(selectedRow.id)
        .then((detailsResponse) => {
          const baseRow = detailsResponse?.data || selectedRow;
          const updatedRow = {
            ...baseRow,
            assignedUser: selectedUser,
            assignedUserId: selectedUser?.id,
            assignedUserName: selectedUser?.name,
            assignedUserEmail: selectedUser?.email,
            assignor: user?.email,
            assignmentDate,
            operation: "ASSIGNMENT",
          };
          return updateOrderApi(updatedRow.id, updatedRow).then(() => updatedRow);
        })
        .then((updatedRow) => {
          toast.success(
            `Purchase order assigned to ${updatedRow.assignedUser.name} successfully.`,
            { autoClose: 4000 },
          );
          if (rows && setRows) {
            const idx = rows.findIndex(row => row.id === updatedRow.id);

            if (idx !== -1) {
              const newRows = [...rows];
              newRows[idx] = {
                ...newRows[idx],
                assignedUser: selectedUser,
                assignedUserId: selectedUser?.id,
                assignedUserName: selectedUser?.name,
                assignedUserEmail: selectedUser?.email,
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT"
              };
              setRows(newRows);
            }
          }
          setSelectedData((prevSelectedData) =>
            prevSelectedData.map((row) =>
              row.id === updatedRow.id
                ? {
                    ...row,
                    assignedUser: selectedUser,
                    assignedUserId: selectedUser?.id,
                    assignedUserName: selectedUser?.name,
                    assignedUserEmail: selectedUser?.email,
                    assignor: user?.email,
                    assignmentDate,
                    operation: "ASSIGNMENT",
                  }
                : row,
            ),
          );
          closeAssignUserDialog();
        })
        .catch((error) => {
          toast.error("Something went wrong.");
          console.log(error.response.data);
        });
    }
  };

  const handleDecline = () => {
    if (selectedRow) {
      const note = declineNote || "";
      const updatedRow = {
        ...selectedRow,
        declineNote: declineNote,
        approvalStatus: "Declined",
        operation: "DECLINE",
      };
      updateOrderApi(updatedRow.id, updatedRow)
        .then((response) => {
          toast.success(`Purchase order declined successfully.`, {
            autoClose: 4000,
          });
          if (rows && setRows) {
            const idx = rows.findIndex(row => row.id === updatedRow.id);

            if (idx !== -1) {
              const newRows = [...rows];
              newRows[idx] = {
                ...newRows[idx],
                declineNote: declineNote,
                approvalStatus: "Declined",
                operation: "DECLINE"
              };
              setRows(newRows);
            }
          }
        })
        .catch((error) => {
          toast.error("Something went wrong.");
          console.log(error.response.data);
        });
      closeDeclineDialog();
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const [showShipmentRequestPopup, setShowShipmentRequestPopup] = useState({
    visible: false,
    data: null,
  });

  const [componentsState, setComponentsState] = useState({
    origin: {
      dropdownOpen: false,
      inputValue: "",
    },
    item: {
      dropdownOpen: false,
      inputValue: "",
    },
    vendor: {
      dropdownOpen: false,
      inputValue: "",
    },
    type: {
      dropdownOpen: false,
      inputValue: "",
    },
    leafForm: {
      dropdownOpen: false,
      inputValue: "",
    },
    storage: {
      dropdownOpen: false,
      inputValue: "",
    },
    cost: {
      dropdownOpen: false,
      inputValue: "",
    },
    firstSample: {
      dropdownOpen: false,
      inputValue: "",
    },
    secondSample: {
      dropdownOpen: false,
      inputValue: "",
    },
    paymentTerm: {
      dropdownOpen: false,
      inputValue: "",
    },
    offer: {
      dropdownOpen: false,
      inputValue: "",
    },
    order: {
      dropdownOpen: false,
      inputValue: "",
    },
  });

  const [item, setItem] = useState([]);
  const [sample, setSample] = useState([]);
  const navigate = useNavigate();
  const [offer, setOffer] = useState([]);
  const [loadingRecord, setLoadingRecord] = useState(null);
  const [blockData, setBlockData] = useState([]);
  const [blocksOpen, setBlocksOpen] = useState(false);

  const openBlocksDialog = (blocks) => {
    setBlockData(Array.isArray(blocks) ? blocks : []);
    setBlocksOpen(true);
  };

  const updateComponentState = (componentKey, newState) => {
    setComponentsState((prevState) => ({
      ...prevState,
      [componentKey]: {
        ...prevState[componentKey],
        ...newState,
      },
    }));
  };

  const [filterVendorOrder, setFilterVendorOrder] = useState({
    id: 0,
    orderType: "VENDOR",
    stakeHolderType: "VENDOR",
    itemBuyingGrade: "",
    itemIdList: [],
    stakeholderIdList: [],
    costIdList: [],
    offerIdList: [],
    companyList: [],
    approvalStatusList: [],
    orderStatusList: [],
    vendorList: [],
    firstSampleId: "",
    secondSampleId: "",
    costId: "",
    firstSampleIdList: [],
    secondSampleIdList: [],
    firstSampleStatusList: [],
    secondSampleStatusList: [],
    paymentTerm: "",
    paymentTermList: [],
    incotermList: [],
    portOfLoadingList: [],
    portOfDischargeList: [],
    packagingList: [],
    volumeUnitList: [],
    firstPriceCurrencyList: [],
    finalPriceCurrencyList: [],
    remark: "",
    shipmentSchedule: "",
    comment: "",
    documentStatusList: [],
    tobaccoCode: "",
    salesGrade: "",
    buyingGrade: "",
    customerGrade: "",
    internalGrade: "",
    originList: [],
    typeList: [],
    leafFormList: [],
    colorList: [],
    storageList: [],
    itemStorage: "",
    recordStatusList: ["ACTIVE"],
    showIssueDateFields: false,
    orderIdList: [],
  });

  useEffect(() => {
    retrieveVendorOrders();
    getMaxOrderNumber();
    retrieveUsers();
  }, []);

  function retrieveUsers() {
    retrieveUsersApi()
      .then((response) => {
        setUsers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function approveOrder(orderId) {
    approveOrderApi(orderId)
      .then((response) => {
        toast.success("Order approved successfully.");
        if (rows && setRows) {
          const idx = rows.findIndex(row => row.id === orderId);

          if (idx !== -1) {
            const newRows = [...rows];
            newRows[idx] = { ...newRows[idx], approvalStatus: "Approved" };
            setRows(newRows);
          }
        }
      })
      .catch((error) => {
        toast.error("No Authorization");
        console.log(error.response.data);
      });
  }

  const openBulkAssignDialog = () => {
    if (!selectedData.length) {
      toast.error("Please select at least one order.");
      return;
    }
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`You can select up to ${MAX_BULK_SELECTION} orders for bulk actions.`);
      return;
    }
    setBulkSelectedUser("");
    setIsBulkAssignDialogOpen(true);
  };

  const closeBulkAssignDialog = () => {
    setBulkSelectedUser("");
    setIsBulkAssignDialogOpen(false);
  };

  const openBulkApproveDialog = () => {
    if (!selectedData.length) {
      toast.error("Please select at least one order.");
      return;
    }
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`You can select up to ${MAX_BULK_SELECTION} orders for bulk actions.`);
      return;
    }
    setIsBulkApproveDialogOpen(true);
  };

  const closeBulkApproveDialog = () => {
    setIsBulkApproveDialogOpen(false);
  };

  const handleBulkAssignment = async () => {
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`Bulk assignment supports up to ${MAX_BULK_SELECTION} orders at once.`);
      return;
    }

    if (!bulkSelectedUser) {
      toast.error("Please select a user.");
      return;
    }

    const eligibleRows = selectedData.filter((row) => row?.approvalStatus !== "Approved");
    if (!eligibleRows.length) {
      toast.error("Selected orders are already approved and cannot be reassigned.");
      return;
    }

    const assignmentDate = new Date();
    const results = await Promise.allSettled(
      eligibleRows.map(async (row) => {
        const detailsResponse = await retrieveOrderByIdApi(row.id);
        const baseRow = detailsResponse?.data || row;
        const updatedRow = {
          ...baseRow,
          assignedUser: bulkSelectedUser,
          assignedUserId: bulkSelectedUser?.id,
          assignedUserName: bulkSelectedUser?.name,
          assignedUserEmail: bulkSelectedUser?.email,
          assignor: user?.email,
          assignmentDate,
          operation: "ASSIGNMENT",
        };
        return updateOrderApi(updatedRow.id, updatedRow);
      }),
    );

    const successCount = results.filter((result) => result.status === "fulfilled").length;
    const failedCount = results.length - successCount;

    if (successCount > 0) {
      const successIds = new Set(
        eligibleRows
          .filter((_, index) => results[index].status === "fulfilled")
          .map((row) => row.id),
      );
      setRows((prevRows) =>
        prevRows.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                assignedUser: bulkSelectedUser,
                assignedUserId: bulkSelectedUser?.id,
                assignedUserName: bulkSelectedUser?.name,
                assignedUserEmail: bulkSelectedUser?.email,
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT",
              }
            : row,
        ),
      );
      setSelectedData((prevSelectedData) =>
        prevSelectedData.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                assignedUser: bulkSelectedUser,
                assignedUserId: bulkSelectedUser?.id,
                assignedUserName: bulkSelectedUser?.name,
                assignedUserEmail: bulkSelectedUser?.email,
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT",
              }
            : row,
        ),
      );
    }

    if (successCount > 0) {
      toast.success(`${successCount} purchase order(s) assigned successfully.`);
    }
    if (failedCount > 0) {
      toast.error(`${failedCount} purchase order(s) could not be assigned.`);
    }

    closeBulkAssignDialog();
  };

  const isAssignedToCurrentUser = (row) => {
    if (!row || !user) {
      return false;
    }

    const currentUserId = user?.id ?? user?.userId;
    const currentUserEmail = (user?.email || user?.username || "").trim().toLowerCase();
    const currentUserName = (user?.name || "").trim().toLowerCase();

    const assignedUserId = row?.assignedUserId ?? row?.assignedUser?.id;
    const assignedUserEmail = (row?.assignedUserEmail || row?.assignedUser?.email || "").trim().toLowerCase();
    const assignedUserName = (row?.assignedUserName || row?.assignedUser?.name || "").trim().toLowerCase();

    if (
      currentUserId != null
      && assignedUserId != null
      && String(currentUserId) === String(assignedUserId)
    ) {
      return true;
    }

    if (currentUserEmail && assignedUserEmail && currentUserEmail === assignedUserEmail) {
      return true;
    }

    if (currentUserName && assignedUserName && currentUserName === assignedUserName) {
      return true;
    }

    return false;
  };

  const handleBulkApprove = async () => {
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`Bulk approval supports up to ${MAX_BULK_SELECTION} orders at once.`);
      return;
    }

    const notOwnedRows = selectedData.filter(
      (row) => !isAssignedToCurrentUser(row),
    );
    const eligibleRows = selectedData.filter(
      (row) => row?.approvalStatus !== "Approved"
        && row?.orderStatus !== "Cancelled"
        && row?.orderStatus !== "Closed"
        && isAssignedToCurrentUser(row),
    );

    if (notOwnedRows.length > 0) {
      toast.error(
        `${notOwnedRows.length} selected order(s) are not assigned to you and were skipped.`,
      );
    }

    if (!eligibleRows.length) {
      toast.error("No selected order is eligible for approval by you.");
      return;
    }

    const results = await Promise.allSettled(
      eligibleRows.map((row) => approveOrderApi(row.id)),
    );

    const successCount = results.filter((result) => result.status === "fulfilled").length;
    const failedCount = results.length - successCount;

    if (successCount > 0) {
      const successIds = new Set(
        eligibleRows
          .filter((_, index) => results[index].status === "fulfilled")
          .map((row) => row.id),
      );
      setRows((prevRows) =>
        prevRows.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                approvalStatus: "Approved",
              }
            : row,
        ),
      );
    }

    if (successCount > 0) {
      toast.success(`${successCount} purchase order(s) approved successfully.`);
    }
    if (failedCount > 0) {
      toast.error(`${failedCount} purchase order(s) could not be approved.`);
    }

    closeBulkApproveDialog();
  };

  const cancelOrder = async (order) => {
    setLoadingRecord(order?.id);
    const updatedOrderData = {
      ...order,
      recordStatus: "PASSIVE",
      orderStatus: "Cancelled",
      operation: "Cancelling",
    };
    try {
      const response = await updateOrderApi(order?.id, updatedOrderData);
      toast.success("Order cancelled successfully.");
      if (rows && setRows) {
        const idx = rows.findIndex(row => row.id === updatedOrderData.id);

        if (idx !== -1) {
          const newRows = [...rows];
          newRows[idx] = {
            ...newRows[idx],
            recordStatus: "PASSIVE",
            orderStatus: "Cancelled",
            operation: "Cancelling"
          };
          setRows(newRows);
        }
      }
    } catch (error) {
      console.log(error.response.data);
      if (error?.response?.status === 409) {
        const { message, blocks } = error.response.data;
        openBlocksDialog(blocks);
        toast.error(message);
        return;
      }
      toast.error("Something went wrong. ", error.response.data);
    } finally {
      setLoadingRecord(null);
    }
  }

  function retrieveVendorOrders(target = "rows") {
    retrieveFastOrdersApi("VENDOR")
      .then((response) => {
        if (target === "rows") {
          setRows(response?.data);
        } else if (target === "orders") {
          setOrders(response?.data);
        }
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveItems() {
    retrieveAllItemsApi()
      .then((response) => {
        setItems(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveItemById(id) {
    retrieveItemByIdApi(id)
      .then((response) => {
        setItem(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveOffers() {
    retrieveFastOffersApi("VENDOR")
      .then((response) => {
        setOffers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveOfferById(id) {
    retrieveOfferByIdApi(id)
      .then((response) => {
        setOffer(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveVendors() {
    retrieveFastStakeholdersApi("VENDOR")
      .then((response) => {
        setVendors(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveSamples() {
    retrieveAllSamplesApi()
      .then((response) => {
        setSamples(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function retrieveSampleById(id) {
    retrieveSampleByIdApi(id)
      .then((response) => {
        setSample(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function getMaxOrderNumber() {
    retrieveMaxOrderNumberApi("VENDOR")
      .then((response) => {
        console.log(response?.data);
        setMaxOrderGroupNumber(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const newOrderGroupNumber =
    maxOrderGroupNumber + (Math.floor(Math.random() * 5) + 1);

  const [editVendorOrder, setEditVendorOrder] = useState({
    visible: false,
    data: null,
    index: null,
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    } else {
      setSelected([]);
      setSelectedData([]);
    }
  };

  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editVendorOrder],
  );

  if (userLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>Not authorized</div>;
  }

  return (
    <div>
      {addView ? (
        <AddVendorOrder
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          newOrderGroupNumber={newOrderGroupNumber}
        />
      ) : editVendorOrder.visible ? (
        <EditVendorOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editVendorOrder={editVendorOrder}
          setEditVendorOrder={setEditVendorOrder}
          mapOrder={mapOrder}
        />
      ) : showOrderPopup.visible ? (
        <CreateOrder
          setCreateOrder={setShowOrderPopup}
          createOrder={showOrderPopup}
        />
      ) : showShipmentRequestPopup.visible ? (
        <CreatePurchaseOrderShipment
          setCreatePurchaseOrderShipmentRequest={setShowShipmentRequestPopup}
          createPurchaseOrderShipmentRequest={showShipmentRequestPopup}
        />
      ) : editItem.visible ? (
        <EditItem
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editItem={editItem}
          setEditItem={setEditItem}
        />
      ) : editCost.visible ? (
        <EditCost
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCost={editCost}
          setEditCost={setEditCost}
        />
      ) : editSample.visible ? (
        <EditSample
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editSample={editSample}
          setEditSample={setEditSample}
        />
      ) : editVendorOffer.visible ? (
        <EditVendorOffer
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editVendorOffer={editVendorOffer}
          setEditVendorOffer={setEditVendorOffer}
        />
      ) : exportPoPopup.visible ? (
        <ExportPurchaseOrder
          setExportPoPopup={setExportPoPopup}
          exportPoPopup={exportPoPopup}
        />
      ) : (
        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
              >
                {/*} <TextField
                  id="outlined-search"
                  label="Group Number"
                  value={filterVendorOrder?.orderGroupNumber || ""}
                  type="number"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      orderGroupNumber: e.target.value,
                    })
                  }
                />*/}
                <Autocomplete
                  multiple
                  id="outlined-select-order"
                  disableClearable
                  open={componentsState.order.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("order", { dropdownOpen: true })
                  }
                  inputValue={componentsState.order.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("order", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...orders.filter((order) =>
                      filterVendorOrder.orderIdList.includes(order.id),
                    ),
                    ...orders.filter(
                      (order) =>
                        !filterVendorOrder.orderIdList.includes(order.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""} - SAP PO Number: ${option?.purchaseOrderNumber || ""
                    }`
                  }
                  value={orders.filter((order) =>
                    filterVendorOrder.orderIdList.includes(order.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      orderIdList: newValue.map((order) => order.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""} - SAP PO Number: ${option?.purchaseOrderNumber || ""
                        }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterVendorOrder?.orderIdList.length > 0
                        ? `Purchase Orders Selected (${filterVendorOrder?.orderIdList.length})`
                        : "Purchase Order";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.order.inputValue}
                        onChange={(e) =>
                          updateComponentState("order", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={() => retrieveVendorOrders("orders")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("order", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-search"
                  label="SAP PO Number"
                  value={filterVendorOrder?.purchaseOrderNumber || ""}
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      purchaseOrderNumber: e.target.value,
                    })
                  }
                />

                <Autocomplete
                  multiple
                  id="outlined-select-offer"
                  disableClearable
                  open={componentsState.offer.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("offer", { dropdownOpen: true })
                  }
                  inputValue={componentsState.offer.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("offer", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...offers.filter((offer) =>
                      filterVendorOrder.offerIdList.includes(offer.id),
                    ),
                    ...offers.filter(
                      (offer) =>
                        !filterVendorOrder.offerIdList.includes(offer.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""} Offer Number: ${option?.offerYear || ""
                    } - ${option?.offerGroupNumber || ""}`
                  }
                  value={offers.filter((offer) =>
                    filterVendorOrder.offerIdList.includes(offer.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      offerIdList: newValue.map((offer) => offer.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""} Offer Number: ${option?.offerYear || ""
                        } - ${option?.offerGroupNumber || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterVendorOrder?.offerIdList.length > 0
                        ? `Offers Selected (${filterVendorOrder?.offerIdList.length})`
                        : "Offer";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.offer.inputValue}
                        onChange={(e) =>
                          updateComponentState("offer", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveOffers}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("offer", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <FilterSelect
                  label="SG Approval Status"
                  menuType="orderApprovalStatus"
                  value={filterVendorOrder.approvalStatusList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    approvalStatusList: e.target.value,
                  })}
                  multiple
                />

                <FilterSelect
                  label="Buying Company"
                  menuType="companies"
                  value={filterVendorOrder.companyList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    companyList: e.target.value
                  })}
                  multiple
                />

                <Autocomplete
                  multiple
                  id="outlined-select-item"
                  disableClearable
                  open={componentsState.item.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("item", { dropdownOpen: true })
                  }
                  inputValue={componentsState.item.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("item", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[{ id: null, buyingGrade: "-", crop: "" }, ...items]}
                  getOptionLabel={(option) =>
                    option.id !== null
                      ? `ID: ${option?.id || ""} - ${option?.buyingGrade || ""
                      } - ${option?.crop || ""}`
                      : "-"
                  }
                  value={items.filter((item) =>
                    filterVendorOrder.itemIdList.includes(item.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      itemIdList: newValue
                        .map((item) => item.id)
                        .filter((id) => id !== null),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {option.id !== null
                        ? `ID: ${option?.id || ""} - ${option?.buyingGrade || ""
                        } - ${option?.crop || ""}`
                        : "-"}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterVendorOrder?.itemIdList.length > 0
                        ? `Items Selected (${filterVendorOrder?.itemIdList.length})`
                        : "Item";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.item.inputValue}
                        onChange={(e) =>
                          updateComponentState("item", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveItems}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("item", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-search"
                  label="Tobacco Code"
                  value={filterVendorOrder?.tobaccoCode || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      tobaccoCode: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Sales Grade"
                  value={filterVendorOrder?.salesGrade || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      salesGrade: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Buying Grade"
                  value={filterVendorOrder?.buyingGrade || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      buyingGrade: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Internal Grade"
                  value={filterVendorOrder?.internalGrade || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      internalGrade: e.target.value,
                    })
                  }
                />

                <FilterSelect
                  label="Origin"
                  menuType="origin"
                  value={filterVendorOrder.originList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    originList: e.target.value
                  })}
                  multiple
                />

                <FilterSelect
                  label="Type"
                  menuType="type"
                  value={filterVendorOrder.typeList || []}
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      typeList: e.target.value,
                    })}
                  multiple
                />

                <FilterSelect
                  label="Leaf Form"
                  menuType="leafForm"
                  value={filterVendorOrder.leafFormList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    leafFormList: e.target.value
                  })}
                  multiple
                />

                <FilterSelect
                  label="Color"
                  menuType="color"
                  value={filterVendorOrder.colorList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    colorList: e.target.value,
                  })}
                  multiple
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showCropFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showCropFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="crop-year"
                      type="text"
                      label="Crop Year"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.cropFrom && filterVendorOrder?.cropTo
                          ? `${filterVendorOrder.cropFrom} - ${filterVendorOrder.cropTo}`
                          : filterVendorOrder?.cropFrom
                            ? `From ${filterVendorOrder.cropFrom}`
                            : filterVendorOrder?.cropTo
                              ? `To ${filterVendorOrder.cropTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showCropFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showCropFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="crop-year-from"
                          type="number"
                          label="Crop Year From"
                          value={filterVendorOrder?.cropFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              cropFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="crop-year-to"
                          type="number"
                          label="Crop Year To"
                          value={filterVendorOrder?.cropTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              cropTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showCropFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <TextField
                  label="Current Location"
                  type="search"
                  value={filterVendorOrder?.itemStorage || ""}
                  id="outlined-storage"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      itemStorage: e.target.value,
                    })
                  }
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showNicotineFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showNicotineFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="nicotine"
                      type="text"
                      label="Nicotine"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.nicotineFrom && filterVendorOrder?.nicotineTo
                          ? `${filterVendorOrder.nicotineFrom} - ${filterVendorOrder.nicotineTo}`
                          : filterVendorOrder?.nicotineFrom
                            ? `From ${filterVendorOrder.nicotineFrom}`
                            : filterVendorOrder?.nicotineTo
                              ? `To ${filterVendorOrder.nicotineTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showNicotineFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showNicotineFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="nicotine-from"
                          type="number"
                          label="Nicotine From"
                          value={filterVendorOrder?.nicotineFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              nicotineFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="nicotine-to"
                          type="number"
                          label="Nicotine To"
                          value={filterVendorOrder?.nicotineTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              nicotineTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showNicotineFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showSugarFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showSugarFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="sugar"
                      type="text"
                      label="Sugar"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.sugarFrom && filterVendorOrder?.sugarTo
                          ? `${filterVendorOrder.sugarFrom} - ${filterVendorOrder.sugarTo}`
                          : filterVendorOrder?.sugarFrom
                            ? `From ${filterVendorOrder.sugarFrom}`
                            : filterVendorOrder?.sugarTo
                              ? `To ${filterVendorOrder.sugarTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showSugarFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showSugarFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="sugar-from"
                          type="number"
                          label="Sugar From"
                          value={filterVendorOrder?.sugarFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              sugarFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="sugar-to"
                          type="number"
                          label="Sugar To"
                          value={filterVendorOrder?.sugarTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              sugarTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showSugarFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <TextField
                  id="outlined-number"
                  label="Warehouse"
                  value={filterVendorOrder?.warehouse || ""}
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      warehouse: e.target.value,
                    })
                  }
                />
                <Autocomplete
                  multiple
                  id="outlined-select-vendor"
                  disableClearable
                  open={componentsState.vendor.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("vendor", { dropdownOpen: true })
                  }
                  inputValue={componentsState.vendor.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("vendor", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...vendors.filter((vendor) =>
                      filterVendorOrder.stakeholderIdList.includes(vendor.id),
                    ),
                    ...vendors.filter(
                      (vendor) =>
                        !filterVendorOrder.stakeholderIdList.includes(
                          vendor.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    option ? `${option?.id || ""} - ${option?.name || ""}` : ""
                  }
                  value={vendors.filter((vendor) =>
                    filterVendorOrder.stakeholderIdList.includes(vendor.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      stakeholderIdList: newValue.map((vendor) => vendor.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {option
                        ? `${option?.id || ""} - ${option?.name || ""}`
                        : ""}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterVendorOrder?.stakeholderIdList.length > 0
                        ? `Vendors Selected (${filterVendorOrder?.stakeholderIdList.length})`
                        : "Vendor";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.vendor.inputValue}
                        onChange={(e) =>
                          updateComponentState("vendor", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveVendors}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("vendor", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <Autocomplete
                  multiple
                  id="outlined-select-second-sample"
                  disableClearable
                  open={componentsState.secondSample.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("secondSample", { dropdownOpen: true })
                  }
                  inputValue={componentsState.secondSample.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("secondSample", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...samples.filter((sample) =>
                      filterVendorOrder.secondSampleIdList.includes(sample.id),
                    ),
                    ...samples.filter(
                      (sample) =>
                        !filterVendorOrder.secondSampleIdList.includes(
                          sample.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    option
                      ? `${option?.id || ""} - ${option?.remark || ""}`
                      : ""
                  }
                  value={samples.filter((sample) =>
                    filterVendorOrder.secondSampleIdList.includes(sample.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      secondSampleIdList: newValue.map((sample) => sample.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {option
                        ? `${option?.id || ""} - ${option?.remark || ""}`
                        : ""}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterVendorOrder?.secondSampleIdList.length > 0
                        ? `Redrawn Samples Selected (${filterVendorOrder?.secondSampleIdList.length})`
                        : "Redrawn Sample";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.secondSample.inputValue}
                        onChange={(e) =>
                          updateComponentState("secondSample", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveSamples}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("secondSample", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <FilterSelect
                  label="Redrawn Sample Status"
                  menuType="sampleStatus"
                  value={filterVendorOrder.secondSampleStatusList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    secondSampleStatusList: e.target.value,
                  })}
                  multiple
                />

                <FilterSelect
                  label="Packaging"
                  menuType="packagingTypes"
                  value={filterVendorOrder.packagingList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    packagingList: e.target.value,
                  })}
                  multiple
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showNetWeightPerCaseFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showNetWeightPerCaseFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="net-weight-per-case"
                      type="text"
                      label="Net Weight Per Carton"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.netWeightPerCaseFrom &&
                          filterVendorOrder?.netWeightPerCaseTo
                          ? `${filterVendorOrder.netWeightPerCaseFrom} - ${filterVendorOrder.netWeightPerCaseTo}`
                          : filterVendorOrder?.netWeightPerCaseFrom
                            ? `From ${filterVendorOrder.netWeightPerCaseFrom}`
                            : filterVendorOrder?.netWeightPerCaseTo
                              ? `To ${filterVendorOrder.netWeightPerCaseTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showNetWeightPerCaseFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showNetWeightPerCaseFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="net-weight-per-case-from"
                          type="number"
                          label="Net Weight Per Carton From"
                          value={filterVendorOrder?.netWeightPerCaseFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              netWeightPerCaseFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="net-weight-per-case-to"
                          type="number"
                          label="Net Weight Per Carton To"
                          value={filterVendorOrder?.netWeightPerCaseTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              netWeightPerCaseTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showNetWeightPerCaseFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showNumberOfCasesFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showNumberOfCasesFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="number-of-cases"
                      type="text"
                      label="Number Of Cartons"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.numberOfCasesFrom && filterVendorOrder?.numberOfCasesTo
                          ? `${filterVendorOrder.numberOfCasesFrom} - ${filterVendorOrder.numberOfCasesTo}`
                          : filterVendorOrder?.numberOfCasesFrom
                            ? `From ${filterVendorOrder.numberOfCasesFrom}`
                            : filterVendorOrder?.numberOfCasesTo
                              ? `To ${filterVendorOrder.numberOfCasesTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showNumberOfCasesFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showNumberOfCasesFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="number-of-cases-from"
                          type="number"
                          label="Number Of Cartons From"
                          value={filterVendorOrder?.numberOfCasesFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              numberOfCasesFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="number-of-cases-to"
                          type="number"
                          label="Number Of Cartons To"
                          value={filterVendorOrder?.numberOfCasesTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              numberOfCasesTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showNumberOfCasesFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showVolumeFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showVolumeFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="quantity"
                      type="text"
                      label="Quantity"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.volumeFrom && filterVendorOrder?.volumeTo
                          ? `${filterVendorOrder.volumeFrom} - ${filterVendorOrder.volumeTo}`
                          : filterVendorOrder?.volumeFrom
                            ? `From ${filterVendorOrder.volumeFrom}`
                            : filterVendorOrder?.volumeTo
                              ? `To ${filterVendorOrder.volumeTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showVolumeFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showVolumeFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="quantity-from"
                          type="number"
                          label="Quantity From"
                          value={filterVendorOrder?.volumeFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              volumeFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="quantity-to"
                          type="number"
                          label="Quantity To"
                          value={filterVendorOrder?.volumeTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              volumeTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showVolumeFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <FilterSelect
                  label="Quantity Unit"
                  menuType="units"
                  value={filterVendorOrder.volumeUnitList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    volumeUnitList: e.target.value,
                  })}
                  multiple
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showFirstPriceFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showFirstPriceFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="first-offer"
                      type="text"
                      label="First Offer"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.firstPriceFrom &&
                          filterVendorOrder?.firstPriceTo
                          ? `${filterVendorOrder.firstPriceFrom} - ${filterVendorOrder.firstPriceTo}`
                          : filterVendorOrder?.firstPriceFrom
                            ? `From ${filterVendorOrder.firstPriceFrom}`
                            : filterVendorOrder?.firstPriceTo
                              ? `To ${filterVendorOrder.firstPriceTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showFirstPriceFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showFirstPriceFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="first-offer-from"
                          type="number"
                          label="First Offer From"
                          value={filterVendorOrder?.firstPriceFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              firstPriceFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="first-offer-to"
                          type="number"
                          label="First Offer To"
                          value={filterVendorOrder?.firstPriceTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              firstPriceTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showFirstPriceFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>


                <FilterSelect
                  label="First Offer Price Currency"
                  menuType="currencies"
                  value={filterVendorOrder.firstPriceCurrencyList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    firstPriceCurrencyList: e.target.value
                  })}
                  multiple
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showFinalPriceFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showFinalPriceFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="final-offer"
                      type="text"
                      label="Final Price"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.finalPriceFrom &&
                          filterVendorOrder?.finalPriceTo
                          ? `${filterVendorOrder.finalPriceFrom} - ${filterVendorOrder.finalPriceTo}`
                          : filterVendorOrder?.finalPriceFrom
                            ? `From ${filterVendorOrder.finalPriceFrom}`
                            : filterVendorOrder?.finalPriceTo
                              ? `To ${filterVendorOrder.finalPriceTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showFinalPriceFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showFinalPriceFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="final-offer-from"
                          type="number"
                          label="Final Price From"
                          value={filterVendorOrder?.finalPriceFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              finalPriceFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="final-offer-to"
                          type="number"
                          label="Final Price To"
                          value={filterVendorOrder?.finalPriceTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              finalPriceTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showFinalPriceFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <FilterSelect
                  label="Final Price Currency"
                  menuType="currencies"
                  value={filterVendorOrder.finalPriceCurrencyList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    finalPriceCurrencyList: e.target.value
                  })}
                  multiple
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showTotalAmountFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showTotalAmountFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="total-amount"
                      type="text"
                      label="Total Amount"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.totalAmountFrom && filterVendorOrder?.totalAmountTo
                          ? `${filterVendorOrder.totalAmountFrom} - ${filterVendorOrder.totalAmountTo}`
                          : filterVendorOrder?.totalAmountFrom
                            ? `From ${filterVendorOrder.totalAmountFrom}`
                            : filterVendorOrder?.totalAmountTo
                              ? `To ${filterVendorOrder.totalAmountTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showTotalAmountFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showTotalAmountFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="total-amount-from"
                          type="number"
                          label="Total Amount From"
                          value={filterVendorOrder?.totalAmountFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              totalAmountFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="total-amount-to"
                          type="number"
                          label="Total Amount To"
                          value={filterVendorOrder?.totalAmountTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              totalAmountTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showTotalAmountFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showContractValueDateFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showContractValueDateFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="contract-value-date"
                      type="text"
                      label="Contract Value Date"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.contractValueDateFrom &&
                          filterVendorOrder?.contractValueDateTo
                          ? `${filterVendorOrder.contractValueDateFrom}, ${filterVendorOrder.contractValueDateTo}`
                          : filterVendorOrder?.contractValueDateFrom
                            ? `From ${filterVendorOrder.contractValueDateFrom}`
                            : filterVendorOrder?.contractValueDateTo
                              ? `To ${filterVendorOrder.contractValueDateTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showContractValueDateFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showContractValueDateFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="contract-value-date-from"
                          type="date"
                          label="From"
                          value={filterVendorOrder?.contractValueDateFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              contractValueDateFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="contract-value-date-to"
                          type="date"
                          label="To"
                          value={filterVendorOrder?.contractValueDateTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              contractValueDateTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showContractValueDateFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showOperationDateFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showOperationDateFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="operation-date"
                      type="text"
                      label="Issue Date"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.operationDateFrom &&
                          filterVendorOrder?.operationDateTo
                          ? `${filterVendorOrder.operationDateFrom}, ${filterVendorOrder.operationDateTo}`
                          : filterVendorOrder?.operationDateFrom
                            ? `From ${filterVendorOrder.operationDateFrom}`
                            : filterVendorOrder?.operationDateTo
                              ? `To ${filterVendorOrder.operationDateTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showOperationDateFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showOperationDateFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="operation-date-from"
                          type="date"
                          label="From"
                          value={filterVendorOrder?.operationDateFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              operationDateFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="operation-date-to"
                          type="date"
                          label="To"
                          value={filterVendorOrder?.operationDateTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              operationDateTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showOperationDateFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <FilterSelect
                  label="Incoterm"
                  menuType="incoterms"
                  value={filterVendorOrder.incotermList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    incotermList: e.target.value,
                  })}
                  multiple
                />

                <FilterSelect
                  label="Port Of Loading"
                  menuType="portsOfLoading"
                  value={filterVendorOrder.portOfLoadingList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    portOfLoadingList: e.target.value,
                  })}
                  multiple
                />

                <FilterSelect
                  label="Port Of Discharge"
                  menuType="portsOfDischarge"
                  value={filterVendorOrder.portOfDischargeList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    portOfDischargeList: e.target.value,
                  })}
                  multiple
                />


                <FilterSelect
                  label="Payment Term"
                  menuType="paymentTerm"
                  value={filterVendorOrder.paymentTermList || []}
                  onChange={(e) => setFilterVendorOrder({
                    ...filterVendorOrder,
                    paymentTermList: e.target.value
                  })}
                  multiple
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showEstimatedTimeOfDepartureFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showEstimatedTimeOfDepartureFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="estimatedTimeOfDeparture"
                      type="text"
                      label="ETD"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.estimatedTimeOfDepartureFrom && filterVendorOrder?.estimatedTimeOfDepartureTo
                          ? `${filterVendorOrder.estimatedTimeOfDepartureFrom}, ${filterVendorOrder.estimatedTimeOfDepartureTo}`
                          : filterVendorOrder?.estimatedTimeOfDepartureFrom
                            ? `From ${filterVendorOrder.estimatedTimeOfDepartureFrom}`
                            : filterVendorOrder?.estimatedTimeOfDepartureTo
                              ? `To ${filterVendorOrder.estimatedTimeOfDepartureTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showEstimatedTimeOfDepartureFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showEstimatedTimeOfDepartureFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="estimatedTimeOfDeparture-from"
                          type="date"
                          label="From"
                          value={filterVendorOrder?.estimatedTimeOfDepartureFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              estimatedTimeOfDepartureFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="estimatedTimeOfDeparture-to"
                          type="date"
                          label="To"
                          value={filterVendorOrder?.estimatedTimeOfDepartureTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              estimatedTimeOfDepartureTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showEstimatedTimeOfDepartureFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterVendorOrder?.showEstimatedTimeOfArrivalFields) {
                      setFilterVendorOrder({
                        ...filterVendorOrder,
                        showEstimatedTimeOfArrivalFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="estimatedTimeOfArrival"
                      type="text"
                      label="ETA"
                      fullWidth
                      variant="outlined"
                      value={
                        filterVendorOrder?.estimatedTimeOfArrivalFrom && filterVendorOrder?.estimatedTimeOfArrivalTo
                          ? `${filterVendorOrder.estimatedTimeOfArrivalFrom}, ${filterVendorOrder.estimatedTimeOfArrivalTo}`
                          : filterVendorOrder?.estimatedTimeOfArrivalFrom
                            ? `From ${filterVendorOrder.estimatedTimeOfArrivalFrom}`
                            : filterVendorOrder?.estimatedTimeOfArrivalTo
                              ? `To ${filterVendorOrder.estimatedTimeOfArrivalTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterVendorOrder({
                          ...filterVendorOrder,
                          showEstimatedTimeOfArrivalFields: true,
                        })
                      }
                    />
                    {filterVendorOrder?.showEstimatedTimeOfArrivalFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="estimatedTimeOfArrival-from"
                          type="date"
                          label="From"
                          value={filterVendorOrder?.estimatedTimeOfArrivalFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              estimatedTimeOfArrivalFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="estimatedTimeOfArrival-to"
                          type="date"
                          label="To"
                          value={filterVendorOrder?.estimatedTimeOfArrivalTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              estimatedTimeOfArrivalTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterVendorOrder({
                              ...filterVendorOrder,
                              showEstimatedTimeOfArrivalFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>


                <TextField
                  id="outlined-search"
                  label="Shipment Schedule"
                  value={filterVendorOrder?.shipmentSchedule || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      shipmentSchedule: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Remark"
                  value={filterVendorOrder?.remark || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      remark: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Comment"
                  value={filterVendorOrder?.comment || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      comment: e.target.value,
                    })
                  }
                />
                <FilterSelect
                  label="Record Status"
                  menuType="recordStatus"
                  value={filterVendorOrder.recordStatusList || []}
                  onChange={(e) =>
                    setFilterVendorOrder({
                      ...filterVendorOrder,
                      recordStatusList: e.target.value,
                    })
                  }
                  multiple
                />
                <MyFilters
                  componentName="VendorOrderView"
                  filterState={filterVendorOrder}
                  onApply={(saved) => setFilterVendorOrder(saved)}
                />
              </Grid>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    size="small"
                    onClick={() => {
                      retrieveFastFilteredOrdersApi(filterVendorOrder)
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    size="small"
                    onClick={() => {
                      setFilterVendorOrder({
                        id: 0,
                        orderType: "VENDOR",
                        stakeHolderType: "VENDOR",
                        itemBuyingGrade: "",
                        itemIdList: [],
                        stakeholderIdList: [],
                        costIdList: [],
                        offerIdList: [],
                        companyList: [],
                        approvalStatusList: [],
                        orderStatusList: [],
                        customerList: [],
                        firstSampleId: "",
                        secondSampleId: "",
                        costId: "",
                        firstSampleStatusList: [],
                        secondSampleStatusList: [],
                        paymentTerm: "",
                        paymentTermList: [],
                        incotermList: [],
                        portOfLoadingList: [],
                        portOfDischargeList: [],
                        packagingList: [],
                        volumeUnitList: [],
                        firstPriceCurrencyList: [],
                        finalPriceCurrencyList: [],
                        remark: "",
                        shipmentSchedule: "",
                        comment: "",
                        documentStatusList: [],
                        tobaccoCode: "",
                        salesGrade: "",
                        crop: null,
                        cropFrom: null,
                        cropTo: null,
                        nicotine: null,
                        nicotineFrom: null,
                        nicotineTo: null,
                        sugar: null,
                        sugarFrom: null,
                        sugarTo: null,
                        moisture: null,
                        warehouse: null,
                        volume: null,
                        volumeFrom: null,
                        volumeTo: null,
                        netWeightPerCase: null,
                        netWeightPerCaseFrom: null,
                        netWeightPerCaseTo: null,
                        numberOfCases: null,
                        numberOfCasesFrom: null,
                        numberOfCasesTo: null,
                        quantity: null,
                        firstPrice: null,
                        firstPriceFrom: null,
                        firstPriceTo: null,
                        finalPrice: null,
                        finalPriceFrom: null,
                        finalPriceTo: null,
                        totalAmount: null,
                        totalAmountFrom: null,
                        totalAmountTo: null,
                        statusDeadline: null,
                        contractValueDate: null,
                        contractValueDateFrom: null,
                        contractValueDateTo: null,
                        operationDateFrom: null,
                        operationDateTo: null,
                        showOperationDateFields: false,
                        estimatedTimeOfDeparture: null,
                        estimatedTimeOfDepartureFrom: null,
                        estimatedTimeOfDepartureTo: null,
                        estimatedTimeOfArrival: null,
                        estimatedTimeOfArrivalFrom: null,
                        estimatedTimeOfArrivalTo: null,
                        orderGroupNumber: null,
                        firstSampleIdList: [],
                        secondSampleIdList: [],
                        buyingGrade: "",
                        customerGrade: "",
                        internalGrade: "",
                        originList: [],
                        typeList: [],
                        leafFormList: [],
                        colorList: [],
                        storageList: [],
                        itemStorage: "",
                        recordStatusList: ["ACTIVE"],
                        orderIdList: [],
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
              </Grid>
              <br></br>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 2 }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                rows={rows}
                setAddView={setAddView}
                selected={selected}
                setExportPoPopup={setExportPoPopup}
                exportPoPopup={exportPoPopup}
                selectedData={selectedData}
                visibleColumns={visibleColumns}
                setVisibleColumns={setVisibleColumns}
                selectedColumns={selectedColumns}
                setSelectedColumns={setSelectedColumns}
                selectColumnsDialogOpen={selectColumnsDialogOpen}
                setSelectColumnsDialogOpen={setSelectColumnsDialogOpen}
                columnsOrder={columnsOrder}
                setColumnsOrder={setColumnsOrder}
                onOpenBulkAssignDialog={openBulkAssignDialog}
                onOpenBulkApproveDialog={openBulkApproveDialog}
              />
              <Dialog open={isBulkAssignDialogOpen} onClose={closeBulkAssignDialog} maxWidth="md" fullWidth>
                <DialogTitle>Assign Selected Purchase Orders</DialogTitle>
                <DialogContent>
                  <Typography sx={{ mb: 1 }}>
                    You are assigning {selectedData.length} order(s). Review details below before confirming.
                  </Typography>
                  <Select
                    fullWidth
                    size="small"
                    value={bulkSelectedUser}
                    onChange={(e) => setBulkSelectedUser(e.target.value)}
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="">Select a User</MenuItem>
                    {users.map((option) => (
                      <MenuItem key={option.id} value={option}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Order Number</TableCell>
                        <TableCell>Vendor</TableCell>
                        <TableCell>Item</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Current Assignee</TableCell>
                        <TableCell>Approval</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedData.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{(row?.orderYear ? `${row.orderYear}-` : "") + (row?.orderGroupNumber || "")}</TableCell>
                          <TableCell>{row?.stakeholderName || "-"}</TableCell>
                          <TableCell>{row?.offerItemBuyingGrade || row?.offerItemTobaccoCode || "-"}</TableCell>
                          <TableCell>{row?.orderStatus || "N/A"}</TableCell>
                          <TableCell>{row?.assignedUserName || "Unassigned"}</TableCell>
                          <TableCell>{row?.approvalStatus || "N/A"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeBulkAssignDialog}>Cancel</Button>
                  <Button onClick={handleBulkAssignment} disabled={!bulkSelectedUser}>Assign</Button>
                </DialogActions>
              </Dialog>
              <Dialog open={isBulkApproveDialogOpen} onClose={closeBulkApproveDialog} maxWidth="md" fullWidth>
                <DialogTitle>Approve Selected Purchase Orders</DialogTitle>
                <DialogContent>
                  <Typography sx={{ mb: 2 }}>
                    You are approving {selectedData.length} order(s). Review details below before confirming.
                  </Typography>
                  <TableContainer component={Paper}
                    sx={{
                      border: "2px solid #d1dfe8",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}>
                  <Table size="small" sx={{ tableLayout: "fixed", width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Order ID</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>SAP Number</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Vendor</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Buying Grade</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Volume</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Status</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Assigned To</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Approval</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedData.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.id || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.purchaseOrderNumber || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.stakeholderName || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.offerItemBuyingGrade || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.volume || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.orderStatus || "N/A"} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.assignedUserName || "Unassigned"} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.approvalStatus || "N/A"} /></TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  </TableContainer>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeBulkApproveDialog}>Cancel</Button>
                  <Button onClick={handleBulkApprove}>Approve</Button>
                </DialogActions>
              </Dialog>
              <VendorOrderTable
                visibleRows={visibleRows}
                dense={dense}
                isSelected={isSelected}
                handleClick={handleClick}
                emptyRows={emptyRows}
                visibleColumns={visibleColumns}
                onSelectAllClick={handleSelectAllClick}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                numSelected={selected.length}
                rowCount={rows.length}
                setShowButtons={setShowButtons}
                showButtons={showButtons}
                setEditVendorOrder={setEditVendorOrder}
                approveOrder={approveOrder}
                setOrderData={setOrderData}
                openDeclineDialog={openDeclineDialog}
                isDeclineDialogOpen={isDeclineDialogOpen}
                closeDeclineDialog={closeDeclineDialog}
                declineNote={declineNote}
                handleDecline={handleDecline}
                openAssignUserDialog={openAssignUserDialog}
                isAssignUserDialogOpen={isAssignUserDialogOpen}
                closeAssignUserDialog={closeAssignUserDialog}
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
                selectedRow={selectedRow}
                users={users}
                handleAssignment={handleAssignment}
                setShowShipmentRequestPopup={setShowShipmentRequestPopup}
                navigate={navigate}
                loadingRecord={loadingRecord}
                cancelOrder={cancelOrder}
                setEditItem={setEditItem}
                setEditSample={setEditSample}
                setEditVendorOffer={setEditVendorOffer}
                user={user}
              />
              <div style={{
                position: "sticky",
                top: 0,
                background: "white",
                padding: "10px",
                fontWeight: "bold",
                borderBottom: "1px solid #ddd",
                zIndex: 10,
                display: "flex",
                gap: "20px"
              }}>
                <span>Total Quantity: {new Intl.NumberFormat("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2
                }).format(totalVolume)} {rows.length > 0 ? rows[0]?.volumeUnit : ""}</span>

                <span>Total Amount: {new Intl.NumberFormat("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2
                }).format(usdTotalAmount)} {rows.length > 0 ? "USD" : ""}</span>
              </div>
              <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#c8e6c9",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      Created
                    </span>
                    <span>- PO file created</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        background: "#FFCDD2",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      Closed
                    </span>
                    <span>- All Shipped</span>
                  </div>
                </div>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <BlocksDialog
              open={blocksOpen}
              onClose={() => setBlocksOpen(false)}
              blocks={blockData}
            />
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Dense padding"
            />
          </Box>
        </>
      )}
    </div>
  );
}
